import { Product } from '../types';
import { DOCS_ORIGIN } from '../config/site';

/**
 * Khmer translations of src/assets/products.ts, mirrored product-by-product.
 * Accessors in products.ts fall back to the English record whenever a slug is
 * missing here, so partial coverage degrades gracefully.
 */
export const ProductsKm: Product[] = [
  {
    id: 1,
    slug: 'hrms',
    name: 'ការគ្រប់គ្រងធនធានមនុស្ស',
    shortName: 'ធនធានមនុស្ស',
    navLabel: 'គ្រប់គ្រងបុគ្គលិក',
    tagline: 'ជ្រើសរើស វត្តមាន បើកប្រាក់ខែ និងអភិវឌ្ឍបុគ្គលិក ក្នុងប្រព័ន្ធតែមួយ',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/hrms/`,
    description:
      'AKAS គឺជាប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្សពេញលេញ តាំងពីការជ្រើសរើសរហូតដល់ពេលបុគ្គលិកចាកចេញ។ បុគ្គលិកអាចស្នើសុំការឈប់សម្រាក ម៉ោងបន្ថែម ការបណ្តុះបណ្តាល ការជ្រើសរើសបុគ្គលិក និងការលាលែង ដោយខ្លួនឯងតាមផ្ទាំងសេវា។ ផ្នែកធនធានមនុស្សគ្រប់គ្រងការជ្រើសរើស បុគ្គលិក វត្តមាន ការឈប់សម្រាក ការវាយតម្លៃការងារ ការគណនាប្រាក់ខែ (រួមទាំងពន្ធលើប្រាក់ខែ បេឡាជាតិសន្តិសុខសង្គម និងអាយុការ) និងការបណ្តុះបណ្តាល — ជាមួយដំណើរការអនុម័ត អេក្រង់ពហុភាសា និងកំណត់ត្រាដែលរក្សាទុកក្នុងមូលដ្ឋានទិន្នន័យអ៊ិនគ្រីបតែមួយ។',
    images: [
      '/images/products/hr-db-1.png',
      '/images/products/hr-db-2.png',
      '/images/products/hr-employee-list.png',
      '/images/products/hr-employee-form.png',
      '/images/products/hr-employment.png',
      '/images/products/hr-employment-history.png',
      '/images/products/hr-leave-request.png',
      '/images/products/hr-mypayslip.png',
      '/images/products/hr-approval-workflow.png',
    ],
    backgroundImage: '/images/backgrounds/hrms.jpg',
    highlights: [
      'បុគ្គលិកធ្វើដោយខ្លួនឯង៖ ស្នើឈប់សម្រាក ម៉ោងបន្ថែម មើលស្លឹកប្រាក់ខែ ស្នើបណ្តុះបណ្តាល និងលាលែង',
      'គណនាប្រាក់ខែ រួមទាំងពន្ធលើប្រាក់ខែ (TOS01) ទម្រង់អេឡិចត្រូនិករបស់បេឡាជាតិសន្តិសុខសង្គម អាយុការ បញ្ជីធនាគារ និងស្លឹកប្រាក់ខែ',
      'វត្តមានពីឧបករណ៍ស្កេនម្រាមដៃ ការចុះវត្តមានដោយកូដស្កេន តារាងវេន និងតារាងកត់ត្រាម៉ោងធ្វើការ',
      'ដំណើរការអនុម័ត ជាមួយការផ្ទេរសិទ្ធិអនុម័តជាបណ្តោះអាសន្ន',
    ],
    workflow: {
      title: 'ពីការជ្រើសរើសដល់ការចាកចេញ',
      path: 'សំណើជ្រើសរើស → ចាត់ចូលធ្វើការ → វត្តមាន និងឈប់សម្រាក → ប្រាក់ខែ → វាយតម្លៃ → ចាកចេញ',
      steps: [
        {
          title: 'ជ្រើសរើសបុគ្គលិក',
          description:
            'បុគ្គលិកដាក់សំណើជ្រើសរើស ហើយសំណើនោះត្រូវអនុម័ត។ ប្រព័ន្ធបង្កើតជាមុខតំណែងទំនេរ ប្រមូលពាក្យសុំ ជូនដំណឹងដល់បេក្ខជន និងចាត់អ្នកជាប់ជ្រើសរើសចូលក្នុងបញ្ជីបុគ្គលិក។',
        },
        {
          title: 'ចាត់ចូលធ្វើការ',
          description:
            'បង្កើតប្រវត្តិរូបបុគ្គលិក កិច្ចសន្យាការងារ ប្រាក់ខែ ចំនួនថ្ងៃឈប់សម្រាក កាលវិភាគធ្វើការ និងខ្សែរបាយការណ៍។',
        },
        {
          title: 'វត្តមាន និងឈប់សម្រាក',
          description:
            'កត់ត្រាការចុះវត្តមាន ការចេញបេសកកម្ម និងការចុះវត្តមានដោយកូដស្កេន ដំណើរការតារាងកត់ត្រាម៉ោងធ្វើការ និងអនុម័តការឈប់សម្រាកផ្អែកលើសមតុល្យ និងថ្ងៃឈប់សម្រាក។',
        },
        {
          title: 'បើកប្រាក់ខែ និងអភិវឌ្ឍ',
          description:
            'ដំណើរការម៉ោងបន្ថែម ជួររង់ចាំបើកប្រាក់ខែ និងបញ្ជីគណនាប្រាក់ខែ។ បុគ្គលិកធ្វើការវាយតម្លៃការងារ និងស្នើបណ្តុះបណ្តាលបានដោយខ្លួនឯង។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ផ្ទាំងសេវាដោយខ្លួនឯង',
        items: [
          'ស្នើឈប់សម្រាក លុបចោលការឈប់សម្រាក មើលច្បាប់ឈប់សម្រាករបស់ខ្លួន និងប្រតិទិនឈប់សម្រាក',
          'ស្នើទូទាត់ម៉ោងបន្ថែម និងមើលស្លឹកប្រាក់ខែរបស់ខ្លួន',
          'ស្នើបណ្តុះបណ្តាល និងវាយតម្លៃការងារ',
          'ស្នើជ្រើសរើសបុគ្គលិក មើលមុខតំណែងទំនេរ ស្នើលាលែង និងស្នើដកស្តុក',
        ],
      },
      {
        title: 'បុគ្គលិក',
        items: [
          'គ្រប់គ្រងព័ត៌មានបុគ្គលិក៖ លេខសម្គាល់ អ៊ីមែល ខ្សែរបាយការណ៍ អង្គភាពការងារ ប្រាក់ខែ ចំនួនថ្ងៃឈប់សម្រាក និងកាលវិភាគ',
          'កិច្ចសន្យាការងារ ការផ្លាស់តួនាទី ឬដំឡើងតំណែង កំហុសវិន័យ ពានរង្វាន់ និងគ្រោះថ្នាក់ការងារ',
          'ការចាកចេញដោយលាលែង ឬបញ្ឈប់ការងារ ដែលបុគ្គលិកអាចចាប់ផ្តើមដោយខ្លួនឯងបាន',
        ],
      },
      {
        title: 'គណនាប្រាក់ខែ ជាមួយរបាយការណ៍តាមច្បាប់ក្នុងស្រុក',
        items: [
          'ធាតុប្រាក់ខែ គោលនយោបាយប្រាក់ខែ និងរយៈពេលប្រាក់ខែ — រួមទាំងរបៀបពាក់កណ្តាលខែ សម្រាប់ក្រុមហ៊ុនដែលបើកប្រាក់ខែពីរដងក្នុងមួយខែ — ប្រភេទ និងគោលនយោបាយម៉ោងបន្ថែម ប្រាក់បន្ថែមវេន និងគោលនយោបាយថែទាំកូន',
          'ធាតុប្រាក់ខែគណនាដោយរូបមន្ត ជួរពន្ធលើប្រាក់ខែ តារាងចំណាត់ថ្នាក់ ជួររង់ចាំបើកប្រាក់ខែ និងបញ្ជីគណនាប្រាក់ខែ (គណនា ពិនិត្យ អនុម័ត) ជាមួយស្លឹកប្រាក់ខែ',
          'របាយការណ៍តាមច្បាប់៖ PAY004 ទម្រង់អេឡិចត្រូនិកបេឡាជាតិសន្តិសុខសង្គម, PAY005 ពន្ធលើប្រាក់ខែ (TOS01), PAY006 ពន្ធលើអត្ថប្រយោជន៍បន្ថែម, PAY009 អាយុការ, PAY010 មូលនិធិចូលនិវត្តន៍ — ព្រមទាំងបញ្ជីផ្ទេរប្រាក់តាមធនាគារ PAY003/PAY008',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '💻',
        title: 'សេវាដោយខ្លួនឯងតាមអនឡាញ',
        description:
          'បន្ទាប់ពីចូលប្រព័ន្ធ បុគ្គលិកប្រើម៉ឺនុយ «ផ្ទាំងគ្រប់គ្រង» → «សេវាដោយខ្លួនឯង» សម្រាប់សំណើប្រចាំថ្ងៃ៖ កែប្រវត្តិរូប មើលកាលវិភាគ ស្នើឈប់សម្រាក ទាមទារម៉ោងបន្ថែម ចាប់ផ្តើមវាយតម្លៃការងារ ស្នើបណ្តុះបណ្តាល ស្នើជ្រើសរើសបុគ្គលិក ឬដាក់លិខិតលាលែង។ អ្នកគ្រប់គ្រងឃើញសំណើដែលរង់ចាំការអនុម័ត ចំណែកបុគ្គលិកឃើញសំណើ ស្លឹកប្រាក់ខែ មុខតំណែងទំនេរ និងសាររបស់ខ្លួន។ ការផ្ទេរសិទ្ធិអនុម័តជួយឱ្យអ្នកប្រគល់សិទ្ធិអនុម័តជាបណ្តោះអាសន្នបាន។',
        images: [
          '/images/products/hr-ess-leaverequest.png',
          '/images/products/hr-ess-leavecancel.png',
          '/images/products/hr-ess-myleave.png',
          '/images/products/hr-ess-resignrequest.png',
          '/images/products/hr-ess-jobrequisition.png',
          '/images/products/hr-ess-mypendingrequest.png',
        ],
      },
      {
        icon: '👥',
        title: 'ការជ្រើសរើសបុគ្គលិក',
        description:
          'កំណត់សកម្មភាពជូនដំណឹង រួចបង្កើតសំណើជ្រើសរើសបុគ្គលិក (ដោយផ្នែកធនធានមនុស្ស ឬដោយបុគ្គលិកខ្លួនឯង)។ ក្រោយការអនុម័ត អ្នកគ្រប់គ្រងពាក្យសុំសម្រាប់មុខតំណែងនោះ។ បេក្ខជនមើលមុខតំណែងទំនេរសាធារណៈ ឬផ្ទៃក្នុង ហើយដាក់ពាក្យតាមអនឡាញ។ ប្រវត្តិរូបបេក្ខជនរក្សាទុកប្រវត្តិរូប ព័ត៌មានទំនាក់ទំនង និងជំនាញ។ ផ្នែកធនធានមនុស្សអាចជូនដំណឹងដល់បេក្ខជនដែលជាប់ការជ្រើសរើស ឬមិនជាប់ តាមដំណើរការដែលបានកំណត់ រួមទាំងការអានប្រវត្តិរូបដោយបញ្ញាសិប្បនិម្មិត។',
        images: [
          '/images/products/hr-recruit-jobtitle.png',
          '/images/products/hr-recruit-jobrequisition.png',
          '/images/products/hr-recruit-manage-applicants.png',
          '/images/products/hr-recruit-manage-applicants2.png',
          '/images/products/hr-recruit-notify-applicant.png',
          '/images/products/hr-recruit-notify-custom.png',
        ],
      },
      {
        icon: '👤',
        title: 'បុគ្គលិក',
        description:
          'គ្រប់គ្រងគណនីបុគ្គលិក៖ លេខសម្គាល់ អ៊ីមែល ខ្សែរបាយការណ៍ ថ្ងៃចូលធ្វើការ អង្គភាពការងារ ប្រាក់ខែ ចំនួនថ្ងៃឈប់សម្រាក និងកាលវិភាគធ្វើការ។ ដំណើរការការងាររួមមាន ការចាត់ចូលធ្វើការ ការផ្លាស់តួនាទី និងដំឡើងតំណែង ការផ្តល់ធានារ៉ាប់រង ពានរង្វាន់ កំហុសវិន័យ គ្រោះថ្នាក់ និងការបញ្ឈប់ការងារ។ អ្នកអាចបោះពុម្ពកិច្ចសន្យាការងារចេញពីកំណត់ត្រាការងារ។',
        images: [
          '/images/products/hr-employee-list.png',
          '/images/products/hr-employee-form.png',
          '/images/products/hr-employment.png',
          '/images/products/hr-employment-history.png',
          '/images/products/hr-emp-printcontract.png',
        ],
      },
      {
        icon: '📅',
        title: 'ការឈប់សម្រាក និងវត្តមាន',
        description:
          'មុខងារឈប់សម្រាករួមមាន ថ្ងៃឈប់សម្រាកសាធារណៈ ប្រភេទច្បាប់ឈប់សម្រាក វេនធ្វើការ កំណត់ត្រាឈប់សម្រាក ការគណនាសមតុល្យ ប្រតិទិន និងរបាយការណ៍។ ចំណែកវត្តមានមាន គោលនយោបាយ (ច្បាប់យឺត ចេញមុន និងអវត្តមាន) ឧបករណ៍ស្កេនម្រាមដៃ ទីតាំងចុះវត្តមានដោយកូដស្កេន បេសកកម្មការងារក្រៅការិយាល័យ កំណត់ត្រាចុះវត្តមានដើម តារាងវេន ការបំប្លែងទៅជាតារាងកត់ត្រាម៉ោងធ្វើការ និងរបាយការណ៍វត្តមានមិនប្រក្រតី។',
        images: [
          '/images/products/hr-leave-holiday.png',
          '/images/products/hr-leave-leavetype.png',
          '/images/products/hr-leave-workshift.png',
          '/images/products/hr-leave-records.png',
          '/images/products/hr-leave-balance.png',
          '/images/products/hr-leave-report.png',
        ],
      },
      {
        icon: '📊',
        title: 'ការវាយតម្លៃការងារ',
        description:
          'កំណត់សូចនាករសមិទ្ធផលការងារ និងក្រុមចំណាត់ថ្នាក់ រួចបង្កើតទម្រង់វាយតម្លៃមានទម្ងន់ ដែលមានទាំងការវាយតម្លៃដោយខ្លួនឯង និងដោយអ្នកគ្រប់គ្រងផ្ទាល់។ បុគ្គលិកចាប់ផ្តើមវាយតម្លៃតាមសេវាដោយខ្លួនឯង។ ផ្នែកធនធានមនុស្ស និងអ្នកគ្រប់គ្រងតាមដាន អនុម័ត និងបោះពុម្ព។ នៅពេលចាំបាច់ ធនធានមនុស្សក៏អាចបញ្ចូលព័ត៌មានវាយតម្លៃដោយផ្ទាល់បានដែរ។',
        images: [
          '/images/products/hr-perf-kpi.png',
          '/images/products/hr-perf-template.png',
          '/images/products/hr-perf-review.png',
        ],
      },
      {
        icon: '💰',
        title: 'ការគណនាប្រាក់ខែ',
        description:
          'កំណត់ធាតុប្រាក់ខែ ម៉ោងបន្ថែម ពន្ធលើប្រាក់ខែ គោលនយោបាយប្រាក់ខែ រយៈពេលប្រាក់ខែ ប្រាក់បន្ថែមវេន និងគោលនយោបាយថែទាំកូន។ បុគ្គលិកដាក់សំណើម៉ោងបន្ថែមដើម្បីអនុម័ត។ ផ្នែកធនធានមនុស្សបញ្ចូលចំនួនអថេរក្នុងជួររង់ចាំបើកប្រាក់ខែ រួចគណនា ពិនិត្យ និងអនុម័តបញ្ជីគណនាប្រាក់ខែ — បោះពុម្ពស្លឹកប្រាក់ខែ និងបង្កើតរបាយការណ៍ពន្ធ បេឡាជាតិសន្តិសុខសង្គម អាយុការ និងបញ្ជីធនាគារ។',
        images: [
          '/images/products/hr-payroll-element.png',
          '/images/products/hr-payroll-otpolicy.png',
          '/images/products/hr-payroll-salarytax.png',
          '/images/products/hr-payroll-otpayrequest.png',
          '/images/products/hr-payroll-register.png',
          '/images/products/hr-payroll-tos.png',
          '/images/products/hr-payroll-nssf1.png',
          '/images/products/hr-payroll-nssf2.png',
          '/images/products/hr-mypayslip.png',
          '/images/products/hr-payroll-payslip.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS | ការគ្រប់គ្រងធនធានមនុស្ស៖ បុគ្គលិក វត្តមាន ការឈប់សម្រាក ប្រាក់ខែ និងសេវាដោយខ្លួនឯង',
      description:
        'AKAS គ្រប់គ្រងធនធានមនុស្ស រួមមាន ការជ្រើសរើសបុគ្គលិក ការគ្រប់គ្រងបុគ្គលិក វត្តមាន ការឈប់សម្រាក ការវាយតម្លៃការងារ ការគណនាប្រាក់ខែ (ពន្ធ បេឡាជាតិសន្តិសុខសង្គម អាយុការ) ការបណ្តុះបណ្តាល និងសេវាបុគ្គលិកដោយខ្លួនឯង ជាមួយដំណើរការអនុម័ត។',
      keywords:
        'ប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្ស, ការគណនាប្រាក់ខែ, បេឡាជាតិសន្តិសុខសង្គម, ពន្ធលើប្រាក់ខែ, ការគ្រប់គ្រងការឈប់សម្រាក, វត្តមាន, ការជ្រើសរើសបុគ្គលិក, សេវាបុគ្គលិកដោយខ្លួនឯង, AKAS',
    },
    additionalFeatures: [
      {
        icon: '✓',
        title: 'ដំណើរការអនុម័ត',
        description:
          'រៀបចំការអនុម័តច្រើនជំហានសម្រាប់ការឈប់សម្រាក ម៉ោងបន្ថែម សំណើជ្រើសរើសបុគ្គលិក និងច្រើនទៀត។ ផ្ទេរសិទ្ធិអនុម័តបាន នៅពេលអ្នកទទួលបន្ទុកអវត្តមាន។',
      },
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'មានភាសាអង់គ្លេស និងខ្មែរស្រាប់។ អ្នកអាចបន្ថែមភាសាផ្សេងទៀតតាមរយៈការបកប្រែក្នុងផ្នែកគ្រប់គ្រងប្រព័ន្ធ។',
      },
      {
        icon: '📁',
        title: 'ការគ្រប់គ្រងឯកសារ',
        description: 'រក្សាកិច្ចសន្យា ប្រវត្តិរូប និងឯកសារបុគ្គលិក ជាមួយកំណត់ត្រាបុគ្គលិក។',
      },
      {
        icon: '⚙️',
        title: 'ទម្រង់អេក្រង់ និងវាលបន្ថែម',
        description: 'បន្ថែមវាល និងរៀបចំអេក្រង់ឡើងវិញ ដោយមិនចាំបាច់សរសេរកម្មវិធីថ្មី។',
      },
      {
        icon: '🔔',
        title: 'ការជូនដំណឹង',
        description: 'ជូនដំណឹងតាមអ៊ីមែល និងក្នុងកម្មវិធី សម្រាប់សំណើ ការអនុម័ត និងព្រឹត្តិការណ៍ប្រាក់ខែ។',
      },
      {
        icon: '📝',
        title: 'កំណត់ត្រាសវនកម្ម',
        description: 'កំណត់ត្រាទិន្នន័យបង្ហាញថា អ្នកណាបានកែវាលសំខាន់ៗរបស់ធនធានមនុស្ស និងនៅពេលណា។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'កាត់បន្ថយក្រដាសសម្រាប់ផ្នែកធនធានមនុស្ស',
        description:
          'បុគ្គលិកដាក់សំណើឈប់សម្រាក ម៉ោងបន្ថែម បណ្តុះបណ្តាល និងលាលែងដោយខ្លួនឯង។ ផ្នែកធនធានមនុស្សពិនិត្យតែករណីពិសេស ជំនួសការវាយបញ្ចូលទម្រង់ឡើងវិញ។',
      },
      {
        number: '02',
        title: 'ប្រាក់ខែត្រូវតាមច្បាប់ក្នុងស្រុក',
        description:
          'ពន្ធលើប្រាក់ខែ បេឡាជាតិសន្តិសុខសង្គម អាយុការ និងបញ្ជីធនាគារ ស្ថិតក្នុងបញ្ជីគណនាប្រាក់ខែតែមួយ — មិនមែនជាតារាងគណនាដាច់ដោយឡែកដែលត្រូវធ្វើក្រោយទេ។',
      },
      {
        number: '03',
        title: 'កំណត់ត្រាបុគ្គលិកតែមួយ',
        description:
          'ការជ្រើសរើស កិច្ចសន្យា វត្តមាន សមតុល្យឈប់សម្រាក ការវាយតម្លៃ និងស្លឹកប្រាក់ខែ ស្ថិតលើបុគ្គលតែម្នាក់ — ដូច្នេះការផ្លាស់តួនាទី និងការចាកចេញមានភាពស៊ីសង្វាក់គ្នា។',
      },
      {
        number: '04',
        title: 'ការអនុម័តដែលអ្នកបញ្ជាក់បាន',
        description:
          'ដំណើរការដែលកំណត់បាន ការផ្ទេរសិទ្ធិ និងកំណត់ត្រាសវនកម្ម ផ្តល់ផ្លូវដានសម្រាប់ការត្រួតពិនិត្យផ្នែកការងារ ពន្ធ និងការគ្រប់គ្រងផ្ទៃក្នុង។',
      },
    ],
    videos: [
      {
        title: 'ដំណើរការអនុម័តដែលបត់បែនបាន',
        youtubeId: 'Rt-Zk9H0rNg',
        description: 'រៀបចំដំណើរការអនុម័តក្នុង AKAS។',
      },
      {
        title: 'ការអានប្រវត្តិរូបស្វ័យប្រវត្តិ',
        youtubeId: '5-htzI5-TVQ',
        description: 'ការអានប្រវត្តិរូបដោយបញ្ញាសិប្បនិម្មិត ក្នុងការជ្រើសរើសបុគ្គលិក។',
      },
      {
        title: 'ការបង្ហាញ AKAS ជាភាសាខ្មែរ',
        youtubeId: 'sOLBiaDt1IE',
        description: 'ទស្សនាការបង្ហាញ AKAS ជាភាសាខ្មែរ។',
      },
      {
        title: 'ការកែតម្រូវតាមតម្រូវការ',
        youtubeId: 'RlB4MXPjYXs',
        description: 'ការបង្ហាញការរៀបចំទម្រង់អេក្រង់ និងការកែតម្រូវតាមតម្រូវការ។',
      },
    ],
    related: [
      { label: 'វេទិកា និងដំណើរការការងារ', to: '/products/platform' },
      { label: 'គណនេយ្យ', to: '/products/accounting' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើធនធានមនុស្ស', href: `${DOCS_ORIGIN}/en/hrms/` },
    ],
  },
  {
    id: 2,
    slug: 'crm',
    name: 'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន',
    shortName: 'ទំនាក់ទំនងអតិថិជន',
    navLabel: 'ទំនាក់ទំនងអតិថិជន',
    tagline: 'ពីការទាក់ទងដំបូង ដល់សម្រង់តម្លៃជាផ្លូវការ',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/crm/`,
    description:
      'AKAS គ្រប់គ្រងដំណើរការលក់ ចាប់ពីអតិថិជនសក្ដានុពលរហូតដល់សម្រង់តម្លៃ។ កត់ត្រាអតិថិជនសក្ដានុពល បម្លែងជាអតិថិជន តាមដានតម្លៃ និងលទ្ធភាពឈ្នះ ផ្ញើសម្រង់តម្លៃជាផ្លូវការ រួចបន្តក្នុងការគ្រប់គ្រងចំណូល ជាមួយបញ្ជាលក់ វិក្កយបត្រ និងបង្កាន់ដៃ។ ព័ត៌មានអតិថិជនប្រើរួមជាមួយការចេញវិក្កយបត្រ ដូច្នេះផ្នែកលក់ និងហិរញ្ញវត្ថុមើលគណនីតែមួយ។',
    images: [
      '/images/products/crm/crm-leads.png',
      '/images/products/crm/crm-lead-form.png',
      '/images/products/crm/crm-customers.png',
      '/images/products/crm/crm-customer-form.png',
      '/images/products/crm/crm-opportunities.png',
      '/images/products/crm/crm-opportunity-form.png',
      '/images/products/crm/crm-pipeline.png',
      '/images/products/crm/crm-quotations.png',
      '/images/products/crm/crm-quotation-form.png',
      '/images/products/crm/crm-customer-sales-history.png',
      '/images/products/crm/crm-reports.png',
    ],
    backgroundImage: '/images/products/crm/crm-pipeline.png',
    highlights: [
      'អតិថិជនសក្ដានុពលក្លាយជាអតិថិជន និងអាចបង្កើតឱកាសលក់',
      'ដំណាក់កាលលក់ ជាមួយតម្លៃ និងលទ្ធភាពឈ្នះ',
      'សម្រង់តម្លៃឆ្លងការអនុម័ត រួចបម្លែងជាបញ្ជាលក់',
      'ប្រវត្តិលក់អតិថិជន និងរបាយការណ៍ការលក់',
    ],
    workflow: {
      title: 'ពីអតិថិជនសក្ដានុពលដល់សម្រង់តម្លៃ',
      path: 'អតិថិជនសក្ដានុពល → អតិថិជន → ឱកាសលក់ → សម្រង់តម្លៃ → ការគ្រប់គ្រងចំណូល',
      steps: [
        {
          title: 'កត់ត្រាអតិថិជនសក្ដានុពល',
          description: 'កត់ត្រាព័ត៌មានទំនាក់ទំនង និងប្រភព ដើម្បីកុំឱ្យការតាមដានបាត់ក្នុងប្រអប់សារ។',
        },
        {
          title: 'បម្លែងជាអតិថិជន',
          description: 'បង្កើតគណនីអតិថិជនដែលប្រើរួមក្នុងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន និងការគ្រប់គ្រងចំណូល ហើយអាចបន្ថែមឱកាសលក់បាន។',
        },
        {
          title: 'ធ្វើការលើឱកាសលក់',
          description: 'តាមដានតម្លៃ ដំណាក់កាល និងលទ្ធភាពឈ្នះ នៅលើដំណើរការលក់ដែលក្រុមអាចគ្រប់គ្រងបានពិតប្រាកដ។',
        },
        {
          title: 'ចេញសម្រង់តម្លៃ រួចចេញវិក្កយបត្រ',
          description: 'ផ្ញើសម្រង់តម្លៃជាផ្លូវការ។ ក្រោយការអនុម័ត បម្លែងជាបញ្ជាលក់ក្នុងការគ្រប់គ្រងចំណូល។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ទំព័រដំណើរការលក់',
        items: [
          'អតិថិជនសក្ដានុពល អតិថិជន ឱកាសលក់ សម្រង់តម្លៃ និងទិដ្ឋភាពដំណើរការលក់',
          'ប្រវត្តិលក់អតិថិជន តាមបញ្ជាលក់ និងវិក្កយបត្រ',
          'របាយការណ៍សកម្មភាពលក់ និងអត្រាបម្លែងអតិថិជន',
        ],
      },
      {
        title: 'ភ្ជាប់ជាមួយការចេញវិក្កយបត្រ',
        items: [
          'ព័ត៌មានអតិថិជនប្រើរួមជាមួយការគ្រប់គ្រងចំណូល',
          'សម្រង់តម្លៃដែលបានអនុម័តក្លាយជាបញ្ជាលក់ រួចជាវិក្កយបត្រ និងបង្កាន់ដៃ',
          'លក្ខខណ្ឌឥណទានពីផ្នែកគ្រប់គ្រងប្រព័ន្ធ អនុវត្តលើឯកសារលក់',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '👤',
        title: 'អតិថិជនសក្ដានុពល និងអតិថិជន',
        description:
          'កត់ត្រាអតិថិជនសក្ដានុពល បម្លែងជាអតិថិជន និងរក្សាគណនីតែមួយសម្រាប់ប្រវត្តិលក់ សម្រង់តម្លៃ វិក្កយបត្រ និងបង្កាន់ដៃ។ ភ្ជាប់កំណត់ចំណាំ និងឯកសារ ដើម្បីឱ្យអ្នកទូរស័ព្ទបន្ទាប់យល់ស្ថានការណ៍បានភ្លាម។',
        images: [
          '/images/products/crm/crm-leads.png',
          '/images/products/crm/crm-lead-form.png',
          '/images/products/crm/crm-customers.png',
          '/images/products/crm/crm-customer-form.png',
        ],
      },
      {
        icon: '📊',
        title: 'ឱកាសលក់ និងដំណើរការលក់',
        description:
          'តាមដានតម្លៃ ដំណាក់កាល និងលទ្ធភាពឈ្នះ។ ទិដ្ឋភាពដំណើរការលក់បង្ហាញថាចំណូលកំពុងស្ថិតនៅណា ដូច្នេះអ្នកគ្រប់គ្រងអាចណែនាំក្រុមលក់បានត្រង់ចំណុច មិនមែនគ្រាន់តែមើលវិក្កយបត្រខែមុន។',
        images: [
          '/images/products/crm/crm-opportunities.png',
          '/images/products/crm/crm-opportunity-form.png',
          '/images/products/crm/crm-pipeline.png',
        ],
      },
      {
        icon: '📝',
        title: 'សម្រង់តម្លៃ',
        description:
          'បង្កើតសម្រង់តម្លៃតាមធាតុ ជាមួយពន្ធ ការបញ្ចុះតម្លៃ និងលក្ខខណ្ឌទូទាត់។ បញ្ជូនឱ្យអនុម័ត ផ្ញើទៅអតិថិជន រួចបម្លែងជាបញ្ជាលក់ ដោយមិនវាយបញ្ចូលជួរទំនិញឡើងវិញ។',
        images: [
          '/images/products/crm/crm-quotations.png',
          '/images/products/crm/crm-quotation-form.png',
        ],
      },
      {
        icon: '📈',
        title: 'ប្រវត្តិលក់ និងរបាយការណ៍',
        description:
          'មើលថាអតិថិជនបានទិញអ្វី សម្រង់តម្លៃណាបានប្រែជាការលក់ និងដំណើរការលក់កំពុងដើរយ៉ាងណា — ដោយប្រើទំនិញ និងពន្ធដូចគ្នានឹងការគ្រប់គ្រងចំណូល។',
        images: [
          '/images/products/crm/crm-customer-sales-history.png',
          '/images/products/crm/crm-reports.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS | ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន៖ អតិថិជនសក្ដានុពល ដំណើរការលក់ សម្រង់តម្លៃ និងប្រវត្តិអតិថិជន',
      description:
        'AKAS ជួយតាមដានអតិថិជនសក្ដានុពល អតិថិជន ឱកាសលក់ សម្រង់តម្លៃ និងដំណើរការលក់ រួចបន្តទៅបញ្ជាលក់ និងការចេញវិក្កយបត្រក្នុងការគ្រប់គ្រងចំណូល។',
      keywords:
        'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន, ដំណើរការលក់, សម្រង់តម្លៃ, អតិថិជនសក្ដានុពល, ការគ្រប់គ្រងអតិថិជន, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ធ្វើការលក់ជាភាសាដែលក្រុមរបស់អ្នកប្រើពិតប្រាកដ។',
      },
      {
        icon: '✓',
        title: 'ការអនុម័តសម្រង់តម្លៃ',
        description: 'ការបញ្ចុះតម្លៃ និងសម្រង់តម្លៃធំ ត្រូវឆ្លងកាត់ការអនុម័ត មុនពេលក្លាយជាបញ្ជាលក់។',
      },
      {
        icon: '🔔',
        title: 'ការជូនដំណឹង',
        description: 'ជូនដំណឹងដល់អ្នកទទួលបន្ទុក នៅពេលមានការចាត់តាំងអតិថិជនសក្ដានុពល ឬសម្រង់តម្លៃត្រូវការអនុម័ត។',
      },
      {
        icon: '🔌',
        title: 'ទិន្នន័យមូលដ្ឋានរួម',
        description: 'ទំនិញ ពន្ធ លក្ខខណ្ឌឥណទាន និងអតិថិជន ប្រើឡើងវិញក្នុងការគ្រប់គ្រងចំណូល ការលក់តាមបញ្ជរ និងហាងអនឡាញ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'មិនវាយបញ្ចូលឡើងវិញ ពីសម្រង់តម្លៃដល់វិក្កយបត្រ',
        description:
          'សម្រង់តម្លៃដែលបានអនុម័តក្លាយជាបញ្ជាលក់។ ផ្នែកលក់ និងហិរញ្ញវត្ថុលែងរក្សាកំណែពីរនៃកិច្ចព្រមព្រៀងតែមួយ។',
      },
      {
        number: '02',
        title: 'ដំណើរការលក់ដែលព្យាករណ៍បាន',
        description:
          'ដំណាក់កាល តម្លៃ និងលទ្ធភាពឈ្នះ ស្ថិតលើឱកាសលក់ — មិនមែនក្នុងតារាងគណនាផ្ទាល់ខ្លួនទេ។',
      },
      {
        number: '03',
        title: 'កំណត់ត្រាអតិថិជនតែមួយ',
        description:
          'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន ការចេញវិក្កយបត្រ បង្កាន់ដៃ និងប្រាក់កក់ សុទ្ធតែភ្ជាប់ទៅគណនីអតិថិជនតែមួយ។',
      },
      {
        number: '04',
        title: 'ការផ្ទេរការងារដោយមិនបាត់ព័ត៌មាន',
        description:
          'នៅពេលឈ្នះសម្រង់តម្លៃ ការគ្រប់គ្រងចំណូលមានអតិថិជន ទំនិញ ពន្ធ និងលក្ខខណ្ឌរួចហើយ។',
      },
    ],
    related: [
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
      { label: 'ការលក់តាមបញ្ជរ', to: '/products/pos' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើទំនាក់ទំនងអតិថិជន', href: `${DOCS_ORIGIN}/en/crm/` },
    ],
  },
  {
    id: 3,
    slug: 'insurance',
    name: 'ការគ្រប់គ្រងធានារ៉ាប់រង',
    shortName: 'ធានារ៉ាប់រង',
    tagline: 'បណ្ណធានារ៉ាប់រង អតិថិជន ការទាមទារ និងការបន្ត',
    featured: false,
    description:
      'AKAS គ្រប់គ្រងធានារ៉ាប់រង ជួយភ្នាក់ងារ និងក្រុមហ៊ុនធានារ៉ាប់រង រក្សាព័ត៌មានបណ្ណ ប្រវត្តិអតិថិជន ការទាមទារ និងការបន្ត នៅកន្លែងតែមួយ — ជាមួយការរំលឹក ការរក្សាឯកសារ និងរបាយការណ៍។',
    images: ['/images/products/insurance.jpeg'],
    backgroundImage: '/images/products/insurance.jpeg',
    highlights: [
      'បញ្ជីបណ្ណធានារ៉ាប់រង ជាមួយវិសាលភាពធានា និងថ្ងៃបន្ត',
      'ប្រវត្តិអតិថិជន និងកំណត់ត្រាទំនាក់ទំនង',
      'ការទាមទារ តាំងពីការដាក់ពាក្យរហូតដល់ការដោះស្រាយ',
      'ការរំលឹកថ្ងៃបន្ត និងសម្រង់តម្លៃបន្ត',
    ],
    mainFeatures: [
      {
        icon: '📊',
        title: 'ការគ្រប់គ្រងបណ្ណ',
        description:
          'តាមដានបណ្ណ វិសាលភាពធានា និងថ្ងៃបន្ត។ ស្វែងរក ត្រង និងធ្វើរបាយការណ៍លើផលប័ត្រទាំងមូល ជំនួសការរកមើលក្នុងឯកសារដាច់ៗ។',
      },
      {
        icon: '👥',
        title: 'ការគ្រប់គ្រងអតិថិជន',
        description:
          'រក្សាព័ត៌មានផ្ទាល់ខ្លួន ទំនាក់ទំនង ប្រវត្តិបណ្ណ និងកំណត់ត្រាទំនាក់ទំនង លើអតិថិជនម្នាក់ៗ។',
      },
      {
        icon: '📝',
        title: 'ដំណើរការការទាមទារ',
        description:
          'ដំណើរការការទាមទារពីការដាក់ពាក្យដល់ការដោះស្រាយ ជាមួយឯកសារ ស្ថានភាព និងការជូនដំណឹង។',
      },
      {
        icon: '📅',
        title: 'ការគ្រប់គ្រងការបន្ត',
        description:
          'បង្ហាញការបន្តដែលជិតមកដល់ រំលឹកអតិថិជន និងភ្នាក់ងារ ព្រមទាំងបង្កើតសម្រង់តម្លៃសម្រាប់ការបន្ត។',
      },
    ],
    meta: {
      title: 'AKAS គ្រប់គ្រងធានារ៉ាប់រង | បណ្ណ ការទាមទារ និងការបន្ត',
      description:
        'គ្រប់គ្រងបណ្ណធានារ៉ាប់រង អតិថិជន ការទាមទារ និងការបន្ត ជាមួយការរំលឹក ឯកសារ និងរបាយការណ៍ ក្នុង AKAS។',
      keywords: 'ការគ្រប់គ្រងធានារ៉ាប់រង, បណ្ណធានារ៉ាប់រង, ការទាមទារ, ការបន្ត, AKAS',
    },
    additionalFeatures: [
      {
        icon: '💰',
        title: 'ការគណនាបុព្វលាភធានារ៉ាប់រង',
        description: 'គណនាបុព្វលាភធានារ៉ាប់រង ពីកត្តាវាយតម្លៃដែលកំណត់បាន។',
      },
      {
        icon: '🔒',
        title: 'ការរក្សាឯកសារ',
        description: 'រក្សាឯកសារបណ្ណ ឯកសារការទាមទារ និងលិខិតឆ្លើយឆ្លងជាមួយអតិថិជន។',
      },
      {
        icon: '📨',
        title: 'ការទំនាក់ទំនងស្វ័យប្រវត្តិ',
        description: 'អ៊ីមែល និងសារខ្លី សម្រាប់ការបន្ត បុព្វលាភ និងការជូនដំណឹងអំពីការទាមទារ។',
      },
      {
        icon: '⚙️',
        title: 'ដំណើរការការងារតាមតម្រូវការ',
        description: 'ផ្លូវដំណើរការខុសគ្នា តាមប្រភេទបណ្ណ ប្រភេទអតិថិជន និងការទាមទារ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'ប្រតិបត្តិការលឿនជាងមុន',
        description: 'បណ្ណ ការទាមទារ និងការបន្ត លែងស្ថិតក្នុងថតឯកសារដាច់ដោយឡែក។',
      },
      {
        number: '02',
        title: 'សេវាអតិថិជនកាន់តែប្រសើរ',
        description: 'ឆ្លើយតបបានភ្លាម ព្រោះព័ត៌មានបណ្ណ និងប្រវត្តិស្ថិតនៅមុខអ្នក។',
      },
      {
        number: '03',
        title: 'ការបន្តមិនខកខាន',
        description: 'ថ្ងៃបន្ត និងការរំលឹក ស្ថិតលើបណ្ណផ្ទាល់ — មិនមែនក្នុងប្រតិទិនដែលគ្មាននរណាមើលឃើញទេ។',
      },
      {
        number: '04',
        title: 'ផ្លូវដានសម្រាប់ការត្រួតពិនិត្យ',
        description: 'ឯកសារ និងប្រវត្តិស្ថានភាព ស្ថិតជាមួយបណ្ណ និងការទាមទារនោះ។',
      },
    ],
  },
  {
    id: 4,
    slug: 'revenues',
    name: 'ការគ្រប់គ្រងចំណូល',
    shortName: 'ចំណូល',
    navLabel: 'ចំណូល',
    tagline: 'ពីសម្រង់តម្លៃដល់សាច់ប្រាក់៖ បញ្ជាលក់ វិក្កយបត្រ បង្កាន់ដៃ និងគណនីត្រូវទទួល',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/revenue/`,
    description:
      'ម៉ូឌុលចំណូល ដើរតាមវដ្តលក់រហូតដល់ទទួលបានសាច់ប្រាក់ក្នុង AKAS។ ក្រោយសម្រង់តម្លៃក្នុងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន អ្នកបញ្ជាក់បញ្ជាលក់ ចេញវិក្កយបត្រ កត់ត្រាបង្កាន់ដៃ ទទួលប្រាក់កក់ពីអតិថិជន និងតាមដានគណនីត្រូវទទួល។ ទំនិញ និងសេវាកម្ម កម្រិតតម្លៃ ពន្ធលើតម្លៃបន្ថែម គូប៉ុងបញ្ចុះតម្លៃ និងការទទួលទូទាត់តាម KHQR កំណត់តែម្តង ហើយប្រើឡើងវិញទាំងការលក់តាមបញ្ជរ និងហាងអនឡាញ។ វិក្កយបត្រដែលបានអនុម័ត អាចចុះទៅសៀវភៅគណនីទូទៅ តាមការកំណត់គណនេយ្យ។',
    images: [
      '/images/products/revenues/revenue-items.png',
      '/images/products/revenues/revenue-item-form.png',
      '/images/products/revenues/revenue-taxes.png',
      '/images/products/revenues/revenue-tax-form.png',
      '/images/products/revenues/revenue-coupons.png',
      '/images/products/revenues/revenue-coupon-form.png',
      '/images/products/revenues/revenue-payment-acceptance.png',
      '/images/products/revenues/revenue-sale-orders.png',
      '/images/products/revenues/revenue-sale-order-form.png',
      '/images/products/revenues/revenue-invoices.png',
      '/images/products/revenues/revenue-invoice-form.png',
      '/images/products/revenues/revenue-receipts.png',
      '/images/products/revenues/revenue-receipt-form.png',
      '/images/products/revenues/revenue-customer-deposits.png',
      '/images/products/revenues/revenue-customer-deposit-form.png',
      '/images/products/revenues/revenue-deposit-applications.png',
      '/images/products/revenues/revenue-deposit-application-form.png',
      '/images/products/revenues/revenue-deposit-refunds.png',
      '/images/products/revenues/revenue-deposit-refund-form.png',
      '/images/products/revenues/revenue-ar-query.png',
      '/images/products/revenues/revenue-item-sales-history.png',
      '/images/products/revenues/revenue-reports.png',
    ],
    backgroundImage: '/images/products/revenues/revenue-sale-orders.png',
    highlights: [
      'បញ្ជាលក់ វិក្កយបត្រ បង្កាន់ដៃ និងប្រាក់កក់អតិថិជន',
      'ទំនិញ ជាមួយកម្រិតតម្លៃ ពន្ធ គូប៉ុងបញ្ចុះតម្លៃ និងប្រភេទទំនិញ',
      'KHQR និងវិធីទូទាត់ផ្សេងទៀត',
      'ស្ថានភាពគណនីត្រូវទទួល និងរបាយការណ៍ចំណូល',
    ],
    workflow: {
      title: 'ពីសម្រង់តម្លៃដល់សាច់ប្រាក់',
      path: 'សម្រង់តម្លៃ → បញ្ជាលក់ → វិក្កយបត្រ → បង្កាន់ដៃ',
      steps: [
        {
          title: 'ចេញសម្រង់តម្លៃក្នុងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន',
          description: 'ផ្ញើសម្រង់តម្លៃដែលមានតម្លៃច្បាស់លាស់។ នៅពេលឈ្នះ បម្លែងជាបញ្ជាលក់ ដោយមិនវាយបញ្ចូលជួរទំនិញឡើងវិញ។',
        },
        {
          title: 'បញ្ជាក់បញ្ជាលក់',
          description: 'អតិថិជនយល់ព្រម បញ្ជាលក់ត្រូវបានអនុម័ត ហើយអាចកក់ស្តុកទុកជាមុន។',
        },
        {
          title: 'ចេញវិក្កយបត្រ',
          description: 'ចេញវិក្កយបត្រសម្រាប់ទំនិញ ឬសេវាកម្ម។ ស្តុកនៃទំនិញដែលតាមដានចំនួន ត្រូវដកចេញនៅពេលចេញវិក្កយបត្រ។',
        },
        {
          title: 'ប្រមូលប្រាក់',
          description: 'កត់ត្រាបង្កាន់ដៃ កាត់ប្រាក់កក់របស់អតិថិជន ឬសងប្រាក់កក់ដែលមិនបានប្រើ។ ពិនិត្យគណនីត្រូវទទួលបានគ្រប់ពេល។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំ',
        items: [
          'ទំនិញ និងសេវាកម្ម រួមទាំងកម្រិតតម្លៃ',
          'ការកំណត់ពន្ធលើតម្លៃបន្ថែម និងពន្ធលក់',
          'គូប៉ុងបញ្ចុះតម្លៃ និងលេខកូដបញ្ចុះតម្លៃ',
          'វិធីទូទាត់ ដូចជា KHQR',
          'ប្រភេទទំនិញ ជាមួយការកំណត់គណនីសៀវភៅគណនីទូទៅតាមជម្រើស',
        ],
      },
      {
        title: 'ប្រតិបត្តិការ និងរបាយការណ៍',
        items: [
          'បញ្ជាលក់ វិក្កយបត្រ និងបង្កាន់ដៃ',
          'ប្រាក់កក់អតិថិជន ការកាត់ប្រាក់កក់ និងការសងប្រាក់កក់វិញ',
          'ស្ថានភាពគណនីត្រូវទទួល',
          'ប្រវត្តិលក់ទំនិញ តាមលម្អិត ឬតាមអតិថិជន',
          'របាយការណ៍ចំណូល',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '📦',
        title: 'ទំនិញ ពន្ធ និងកម្រិតតម្លៃ',
        description:
          'ថែទាំទំនិញ និងសេវាកម្មដែលអ្នកលក់ ជាមួយកម្រិតតម្លៃ ពន្ធលើតម្លៃបន្ថែម គូប៉ុងបញ្ចុះតម្លៃ និងប្រភេទទំនិញ។ បញ្ជីទំនិញតែមួយនេះ ប្រើសម្រាប់សម្រង់តម្លៃ វិក្កយបត្រ ការលក់តាមបញ្ជរ និងហាងអនឡាញ។',
        images: [
          '/images/products/revenues/revenue-items.png',
          '/images/products/revenues/revenue-item-form.png',
          '/images/products/revenues/revenue-taxes.png',
          '/images/products/revenues/revenue-tax-form.png',
          '/images/products/revenues/revenue-coupons.png',
          '/images/products/revenues/revenue-coupon-form.png',
          '/images/products/revenues/revenue-payment-acceptance.png',
        ],
      },
      {
        icon: '🧾',
        title: 'បញ្ជាលក់ និងវិក្កយបត្រ',
        description:
          'បញ្ជាក់បញ្ជាលក់ពីសម្រង់តម្លៃដែលឈ្នះ រួចចេញវិក្កយបត្រ។ ទំនិញក្នុងស្តុកត្រូវដកចេញនៅពេលចេញវិក្កយបត្រ ដូច្នេះសមតុល្យឃ្លាំង និងការចេញវិក្កយបត្រ ត្រូវគ្នាជានិច្ច។',
        images: [
          '/images/products/revenues/revenue-sale-orders.png',
          '/images/products/revenues/revenue-sale-order-form.png',
          '/images/products/revenues/revenue-invoices.png',
          '/images/products/revenues/revenue-invoice-form.png',
        ],
      },
      {
        icon: '💳',
        title: 'បង្កាន់ដៃ ប្រាក់កក់ និង KHQR',
        description:
          'កត់ត្រាការទូទាត់លើវិក្កយបត្រ ទទួលប្រាក់កក់ពីអតិថិជន រួចកាត់ប្រាក់កក់ ឬសងវិញនៅពេលក្រោយ ព្រមទាំងទទួលទូទាត់ដោយស្កេនកូដ ដូចជា KHQR។ វិក្កយបត្រដែលបានអនុម័តមានតំណចែករំលែក៖ អតិថិជនបើកទំព័រវិក្កយបត្រដ៏ច្បាស់លាស់លើទូរស័ព្ទ បោះពុម្ពជា PDF និងអាចទូទាត់បានភ្លាមៗ — ដូច្នេះអ្នកទទួលបានប្រាក់លឿនជាងមុន។',
        images: [
          '/images/products/revenues/revenue-receipts.png',
          '/images/products/revenues/revenue-receipt-form.png',
          '/images/products/revenues/revenue-customer-deposits.png',
          '/images/products/revenues/revenue-customer-deposit-form.png',
          '/images/products/revenues/revenue-deposit-applications.png',
          '/images/products/revenues/revenue-deposit-application-form.png',
          '/images/products/revenues/revenue-deposit-refunds.png',
          '/images/products/revenues/revenue-deposit-refund-form.png',
        ],
      },
      {
        icon: '📊',
        title: 'គណនីត្រូវទទួល និងរបាយការណ៍',
        description:
          'មើលវិក្កយបត្រដែលមិនទាន់បានទូទាត់ តាមអតិថិជន និងតាមអាយុបំណុល — ដូច្នេះអ្នកគ្រប់គ្រងឥណទានដឹងច្បាស់ថាត្រូវទូរស័ព្ទទៅកាន់អ្នកណា។ របាយការណ៍ពន្ធលើតម្លៃបន្ថែម និងពន្ធកាត់ទុកលើការលក់ សម្រាប់ការប្រកាសពន្ធ ចេញរួចជាស្រេច ហើយវិក្កយបត្រដែលបានកំណត់គណនី ចុះចូលគណនេយ្យផ្ទាល់ សម្រាប់របាយការណ៍ចំណូល និងលំហូរសាច់ប្រាក់។',
        images: [
          '/images/products/revenues/revenue-ar-query.png',
          '/images/products/revenues/revenue-item-sales-history.png',
          '/images/products/revenues/revenue-reports.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS ការគ្រប់គ្រងចំណូល | បញ្ជាលក់ ការចេញវិក្កយបត្រ បង្កាន់ដៃ និងគណនីត្រូវទទួល',
      description:
        'AKAS គ្រប់គ្រងការលក់ពីសម្រង់តម្លៃដល់ការទទួលប្រាក់៖ បញ្ជាលក់ វិក្កយបត្រ បង្កាន់ដៃ ប្រាក់កក់អតិថិជន ការទូទាត់តាម KHQR និងគណនីត្រូវទទួល — រួចចុះចូលសៀវភៅគណនីទូទៅ នៅពេលកំណត់គណនីរួច។',
      keywords:
        'ការចេញវិក្កយបត្រ, បញ្ជាលក់, បង្កាន់ដៃ, KHQR, គណនីត្រូវទទួល, ពន្ធលើតម្លៃបន្ថែម, AKAS',
    },
    additionalFeatures: [
      {
        icon: '💱',
        title: 'ពហុរូបិយប័ណ្ណ',
        description: 'កំណត់តម្លៃ និងទទួលប្រាក់ជារូបិយប័ណ្ណដែលបានកំណត់ ជាមួយអត្រាប្តូរប្រាក់ពីការរៀបចំប្រព័ន្ធ។',
      },
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ឯកសារ និងអេក្រង់ ជាភាសាដែលក្រុមរបស់អ្នក និងអតិថិជនប្រើ។',
      },
      {
        icon: '✓',
        title: 'ការអនុម័ត',
        description: 'អនុម័តបញ្ជាលក់ និងវិក្កយបត្រ តាមដំណើរការអនុម័តតែមួយ ដូចផ្នែកផ្សេងទៀតនៃ AKAS។',
      },
      {
        icon: '📒',
        title: 'ការចុះសៀវភៅគណនីទូទៅ',
        description: 'ការកំណត់ប្រតិបត្តិការ បញ្ជូនវិក្កយបត្រ និងបង្កាន់ដៃដែលបានអនុម័ត ទៅកាន់សៀវភៅគណនី។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'មើលសាច់ប្រាក់បានច្បាស់',
        description: 'បញ្ជាលក់ វិក្កយបត្រ បង្កាន់ដៃ និងប្រាក់កក់ ជាខ្សែតែមួយ — គណនីត្រូវទទួលមិនមែនជាតារាងដាច់ដោយឡែកទេ។',
      },
      {
        number: '02',
        title: 'ស្តុកត្រូវនឹងការចេញវិក្កយបត្រ',
        description: 'ការចេញវិក្កយបត្រលើទំនិញក្នុងស្តុក ដកសមតុល្យឃ្លាំងដោយស្វ័យប្រវត្តិ។',
      },
      {
        number: '03',
        title: 'វិធីទូទាត់ក្នុងស្រុក',
        description: 'KHQR និងវិធីទូទាត់ផ្សេងទៀត ស្ថិតក្បែរបង្កាន់ដៃបែបប្រពៃណី។',
      },
      {
        number: '04',
        title: 'សៀវភៅគណនីដើរតាមការលក់',
        description: 'ប្រតិបត្តិការដែលបានកំណត់គណនី ចុះចូលគណនេយ្យផ្ទាល់ ដូច្នេះមិនចាំបាច់វាយបញ្ចូលរបាយការណ៍ចំណូលពីរដង។',
      },
    ],
    related: [
      { label: 'ទំនាក់ទំនងអតិថិជន', to: '/products/crm' },
      { label: 'ស្តុក', to: '/products/inventory' },
      { label: 'គណនេយ្យ', to: '/products/accounting' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើការគ្រប់គ្រងចំណូល', href: `${DOCS_ORIGIN}/en/revenue/` },
    ],
  },
  {
    id: 5,
    slug: 'expenses',
    name: 'ចំណាយ និងគណនីត្រូវបង់',
    shortName: 'ចំណាយ',
    navLabel: 'ចំណាយ និងការទិញ',
    tagline: 'អ្នកផ្គត់ផ្គង់ វិក្កយបត្រ ការទូទាត់ និងគណនីត្រូវបង់',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/expense/`,
    description:
      '**ចំណាយ (Expenses)** គ្រប់គ្រងគណនីត្រូវបង់ទៅអ្នកផ្គត់ផ្គង់ក្នុងប្រព័ន្ធ AKAS រួមមានទិន្នន័យអ្នកផ្គត់ផ្គង់ មុខទំនិញចំណាយ វិក្កយបត្រអ្នកផ្គត់ផ្គង់ ការទូទាត់វិក្កយបត្រ និងប្រាក់កក់ជូនអ្នកផ្គត់ផ្គង់។ អ្នកអាចចុះបញ្ជីអ្នកផ្គត់ផ្គង់ កត់ត្រាវិក្កយបត្រ ទូទាត់ និងផ្គូផ្គងការទូទាត់ទៅនឹងវិក្កយបត្រ ឬបង់ប្រាក់ជាមុន រួចយកទៅកាត់កងជាមួយវិក្កយបត្រនាពេលក្រោយ ឬស្នើសុំប្រាក់កក់មកវិញ។ ប្រើរបាយការណ៍អំពីបំណុលត្រូវបង់ និងរបាយការណ៍ចំណាយ ដើម្បីតាមដានសមតុល្យដែលនៅជំពាក់ និងចំណាយផ្សេងៗ។ វិក្កយបត្រ និងការទូទាត់ដែលបានអនុម័ត នឹងត្រូវកត់ត្រាទៅក្នុងសៀវភៅគណនីទូទៅ តាមរយៈការកំណត់គណនីក្នុងម៉ូឌុលគណនេយ្យ (Accounting)។ ការបញ្ជាទិញ និងការទទួលទំនិញ ត្រូវបានគ្រប់គ្រងដោយឡែកនៅក្នុងម៉ូឌុលសារពើភណ្ឌ (Inventory)។',
    images: [
      '/images/products/expenses/expense-vendors.png',
      '/images/products/expenses/expense-vendor-form.png',
      '/images/products/expenses/expense-items.png',
      '/images/products/expenses/expense-item-form.png',
      '/images/products/expenses/expense-bills.png',
      '/images/products/expenses/expense-bill-form.png',
      '/images/products/expenses/expense-payments.png',
      '/images/products/expenses/expense-payment-form.png',
      '/images/products/expenses/expense-vendor-deposits.png',
      '/images/products/expenses/expense-vendor-deposit-form.png',
      '/images/products/expenses/expense-vendor-deposit-applications.png',
      '/images/products/expenses/expense-vendor-deposit-application-form.png',
      '/images/products/expenses/expense-vendor-deposit-refunds.png',
      '/images/products/expenses/expense-vendor-deposit-refund-form.png',
      '/images/products/expenses/expense-ap-query.png',
      '/images/products/expenses/expense-reports.png',
    ],
    backgroundImage: '/images/products/expenses/expense-bills.png',
    highlights: [
      'ព័ត៌មានអ្នកផ្គត់ផ្គង់ វិក្កយបត្រ និងការទូទាត់វិក្កយបត្រ',
      'ប្រាក់កក់អ្នកផ្គត់ផ្គង់ ជាមួយការកាត់ប្រើ និងការសងវិញ',
      'ស្ថានភាពគណនីត្រូវបង់ និងរបាយការណ៍ចំណាយ',
      'ចុះចូលគណនេយ្យ នៅពេលកំណត់គណនីសៀវភៅគណនីទូទៅ',
    ],
    workflow: {
      title: 'ពីការទិញដល់ការទូទាត់',
      path: 'អ្នកផ្គត់ផ្គង់ → វិក្កយបត្រ → ការទូទាត់  (ឬ ប្រាក់កក់អ្នកផ្គត់ផ្គង់ → កាត់ប្រើ / សងវិញ)',
      steps: [
        {
          title: 'ចុះឈ្មោះអ្នកផ្គត់ផ្គង់',
          description: 'រក្សាព័ត៌មានអ្នកផ្គត់ផ្គង់ លក្ខខណ្ឌ និងទំនាក់ទំនង តែម្តង — ហើយប្រើរួមទាំងការទិញស្តុក និងទ្រព្យសកម្មអចលនៈ។',
        },
        {
          title: 'កត់ត្រាវិក្កយបត្រ',
          description: 'បញ្ចូលវិក្កយបត្រអ្នកផ្គត់ផ្គង់ ទៅតាមធាតុចំណាយ ឬទំនិញដែលបានទទួល។',
        },
        {
          title: 'ទូទាត់ និងកាត់ប្រាក់',
          description: 'កត់ត្រាការទូទាត់វិក្កយបត្រ រួចកាត់ប្រាក់ទៅលើវិក្កយបត្រដែលនៅមិនទាន់ទូទាត់។',
        },
        {
          title: 'ប្រាក់កក់ នៅពេលបង់ប្រាក់មុន',
          description: 'ទទួលប្រាក់កក់ពីអ្នកផ្គត់ផ្គង់ កាត់ប្រើលើវិក្កយបត្រក្រោយៗ ឬសងចំនួនដែលមិនបានប្រើវិញ។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំ',
        items: [
          'ធាតុចំណាយ និងសេវាកម្មដែលអ្នកទិញ',
          'ព័ត៌មានអ្នកផ្គត់ផ្គង់',
          'ប្រភេទចំណាយរួម ជាមួយការកំណត់គណនីសៀវភៅគណនីទូទៅតាមជម្រើស',
        ],
      },
      {
        title: 'ប្រតិបត្តិការ និងរបាយការណ៍',
        items: [
          'វិក្កយបត្រ និងការទូទាត់វិក្កយបត្រ',
          'ប្រាក់កក់អ្នកផ្គត់ផ្គង់ ការកាត់ប្រើ និងការសងវិញ',
          'ស្ថានភាពគណនីត្រូវបង់',
          'របាយការណ៍ចំណាយ',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '👥',
        title: 'ការគ្រប់គ្រងអ្នកផ្គត់ផ្គង់',
        description:
          'កំណត់ត្រាអ្នកផ្គត់ផ្គង់តែមួយ សម្រាប់វិក្កយបត្រ ការទូទាត់ បញ្ជាទិញ និងការទិញទ្រព្យសកម្ម — រួមទាំងលក្ខខណ្ឌទូទាត់ដែលអ្នកប្រើ។',
        images: [
          '/images/products/expenses/expense-vendors.png',
          '/images/products/expenses/expense-vendor-form.png',
        ],
      },
      {
        icon: '📄',
        title: 'វិក្កយបត្រ និងការទូទាត់',
        description:
          'កត់ត្រាវិក្កយបត្រអ្នកផ្គត់ផ្គង់ ទូទាត់វិក្កយបត្រនោះ និងកាត់ប្រាក់ទៅលើវិក្កយបត្រដែលនៅមិនទាន់ទូទាត់ ដើម្បីឱ្យអាយុបំណុលគណនីត្រូវបង់មានភាពត្រឹមត្រូវ។',
        images: [
          '/images/products/expenses/expense-bills.png',
          '/images/products/expenses/expense-bill-form.png',
          '/images/products/expenses/expense-payments.png',
          '/images/products/expenses/expense-payment-form.png',
        ],
      },
      {
        icon: '💰',
        title: 'ប្រាក់កក់អ្នកផ្គត់ផ្គង់',
        description:
          'បង់ប្រាក់មុនឱ្យអ្នកផ្គត់ផ្គង់ កាត់ប្រាក់កក់ទៅលើវិក្កយបត្រក្រោយៗ ឬសងចំនួនដែលមិនបានប្រើវិញ — ជាមួយផ្លូវដានពេញលេញ។',
        images: [
          '/images/products/expenses/expense-vendor-deposits.png',
          '/images/products/expenses/expense-vendor-deposit-form.png',
          '/images/products/expenses/expense-vendor-deposit-applications.png',
          '/images/products/expenses/expense-vendor-deposit-application-form.png',
          '/images/products/expenses/expense-vendor-deposit-refunds.png',
          '/images/products/expenses/expense-vendor-deposit-refund-form.png',
        ],
      },
      {
        icon: '📊',
        title: 'ស្ថានភាពគណនីត្រូវបង់ និងរបាយការណ៍',
        description:
          'មើលវិក្កយបត្រដែលនៅសល់ តាមអ្នកផ្គត់ផ្គង់ និងថ្ងៃដល់កំណត់។ វិក្កយបត្រ និងការទូទាត់ដែលបានកំណត់គណនី ចុះកំណត់ត្រាគណនី សម្រាប់លំហូរសាច់ប្រាក់ និងរបាយការណ៍ចំណូល។',
        images: [
          '/images/products/expenses/expense-ap-query.png',
          '/images/products/expenses/expense-reports.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS ចំណាយ | អ្នកផ្គត់ផ្គង់ វិក្កយបត្រ ការទូទាត់ និងគណនីត្រូវបង់',
      description:
        'AKAS ជួយតាមដានអ្នកផ្គត់ផ្គង់ វិក្កយបត្រ ការទូទាត់វិក្កយបត្រ ប្រាក់កក់អ្នកផ្គត់ផ្គង់ និងគណនីត្រូវបង់ ព្រមទាំងចុះចូលសៀវភៅគណនីទូទៅតាមជម្រើស។',
      keywords:
        'គណនីត្រូវបង់, វិក្កយបត្រអ្នកផ្គត់ផ្គង់, ការទូទាត់វិក្កយបត្រ, ចំណាយ, ការទិញ, AKAS',
    },
    additionalFeatures: [
      {
        icon: '📦',
        title: 'ភ្ជាប់ជាមួយស្តុក',
        description: 'បញ្ជាទិញ និងការទទួលទំនិញក្នុងការគ្រប់គ្រងស្តុក ប្រើអ្នកផ្គត់ផ្គង់តែមួយ។',
      },
      {
        icon: '✓',
        title: 'ការអនុម័ត',
        description: 'វិក្កយបត្រ និងការទូទាត់ ឆ្លងកាត់ការអនុម័ត មុនពេលចុះបញ្ជី។',
      },
      {
        icon: '📒',
        title: 'ការចុះសៀវភៅគណនីទូទៅ',
        description: 'ការកំណត់គណនី បញ្ជូនគណនីត្រូវបង់ដែលបានអនុម័ត ទៅកាន់សៀវភៅគណនីក្នុងផ្នែកគណនេយ្យ។',
      },
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ផ្នែកហិរញ្ញវត្ថុ និងប្រតិបត្តិការ អាចធ្វើការជាភាសាណាមួយក៏បាន។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'គណនីត្រូវបង់ ត្រូវនឹងឃ្លាំង',
        description: 'អ្នកផ្គត់ផ្គង់ បញ្ជាទិញ ការទទួលទំនិញ និងវិក្កយបត្រ ប្រើទិន្នន័យរួម ដូច្នេះអាចផ្ទៀងផ្ទាត់បីជ្រុងបាន។',
      },
      {
        number: '02',
        title: 'ប្រាក់កក់មិនបាត់',
        description: 'ប្រាក់ដែលបានបង់មុន ត្រូវកាត់ប្រើ ឬសងវិញ ជំនួសការទុកក្នុងគណនីរង់ចាំដែលគ្មាននរណាផ្ទៀងផ្ទាត់។',
      },
      {
        number: '03',
        title: 'បង់តែអ្វីដែលអ្នកជំពាក់ពិតប្រាកដ',
        description: 'ស្ថានភាពគណនីត្រូវបង់ បង្ហាញវិក្កយបត្រដែលនៅមិនទាន់ទូទាត់ មុនពេលអ្នកដាក់បញ្ជាទូទាត់។',
      },
      {
        number: '04',
        title: 'សៀវភៅគណនីដើរតាមការចំណាយ',
        description: 'វិក្កយបត្រ និងការទូទាត់ដែលបានកំណត់គណនី ចុះចូលសៀវភៅគណនីផ្ទាល់ ដោយមិនចាំបាច់ចម្លងបញ្ចូលនៅចុងខែ។',
      },
    ],
    related: [
      { label: 'ស្តុក', to: '/products/inventory' },
      { label: 'គណនេយ្យ', to: '/products/accounting' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើចំណាយ', href: `${DOCS_ORIGIN}/en/expense/` },
    ],
  },
  {
    id: 6,
    slug: 'inventory',
    name: 'ការគ្រប់គ្រងស្តុក',
    shortName: 'ស្តុក',
    navLabel: 'ស្តុក',
    tagline: 'ស្តុក បញ្ជាទិញ ការទទួលទំនិញ ការផ្ទេរ និងសមតុល្យ',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/inventory/`,
    description:
      'ម៉ូឌុលស្តុក ជួយតាមដានចំនួនទំនិញជាក់ស្តែងតាមទីតាំងនានា៖ ទំនិញដែលតាមដានចំនួន បញ្ជាទិញ ការទទួលទំនិញ ការផ្ទេរ ការកែតម្រូវ ការដកស្តុក និងសមតុល្យដែលនៅសល់។ ការលក់តាមការគ្រប់គ្រងចំណូល ដកស្តុកដោយស្វ័យប្រវត្តិ។ បុគ្គលិកអាចស្នើដកស្តុកបានតាមសេវាដោយខ្លួនឯង ហើយសំណើដែលបានអនុម័តនឹងបង្ហាញជាការដកស្តុកសម្រាប់ឃ្លាំង។ ទីតាំងទាំងអស់មកពីផ្នែកគ្រប់គ្រងប្រព័ន្ធ ដូច្នេះហាង និងឃ្លាំងស្ថិតនៅលើផែនទីអង្គភាពតែមួយ។',
    images: [
      '/images/products/inventory/inventory-items.png',
      '/images/products/inventory/inventory-item-form.png',
      '/images/products/inventory/inventory-purchase-orders.png',
      '/images/products/inventory/inventory-purchase-order-form.png',
      '/images/products/inventory/inventory-received.png',
      '/images/products/inventory/inventory-received-form.png',
      '/images/products/inventory/inventory-transfers.png',
      '/images/products/inventory/inventory-transfer-form.png',
      '/images/products/inventory/inventory-adjustments.png',
      '/images/products/inventory/inventory-adjustment-form.png',
      '/images/products/inventory/inventory-withdrawals.png',
      '/images/products/inventory/inventory-withdrawal-form.png',
      '/images/products/inventory/inventory-balances.png',
      '/images/products/inventory/inventory-reports.png',
    ],
    backgroundImage: '/images/products/inventory/inventory-items.png',
    highlights: [
      'បញ្ជាទិញ → ការទទួលទំនិញ → សមតុល្យដែលនៅសល់',
      'ការផ្ទេរ ការកែតម្រូវ និងការដកស្តុក',
      'ស្តុកត្រូវដក នៅពេលចេញវិក្កយបត្រលើទំនិញក្នុងស្តុក',
      'បុគ្គលិកស្នើដកស្តុកដោយខ្លួនឯង',
    ],
    workflow: {
      title: 'ទិញ រក្សាទុក លក់',
      path: 'បញ្ជាទិញ → ទទួលទំនិញ → លក់ (ចេញវិក្កយបត្រ) → ផ្ទៀងផ្ទាត់សមតុល្យ',
      steps: [
        {
          title: 'បញ្ជាទិញពីអ្នកផ្គត់ផ្គង់',
          description: 'បង្កើតបញ្ជាទិញសម្រាប់ទំនិញក្នុងស្តុក ជាមួយអ្នកផ្គត់ផ្គង់ពីផ្នែកចំណាយ។',
        },
        {
          title: 'ទទួលទំនិញចូលទីតាំង',
          description: 'កត់ត្រាការទទួលទំនិញចូលឃ្លាំង ឬហាង។ ចំនួនដែលនៅសល់កើនឡើង។',
        },
        {
          title: 'ផ្ទេរ កែតម្រូវ ឬដកស្តុក',
          description: 'ផ្ទេររវាងទីតាំង កែតម្រូវតាមការរាប់ស្តុក ឬចេញការដកស្តុក (រួមទាំងសំណើដោយខ្លួនឯង)។',
        },
        {
          title: 'លក់ និងផ្ទៀងផ្ទាត់សមតុល្យ',
          description: 'វិក្កយបត្រក្នុងការគ្រប់គ្រងចំណូល ដកស្តុក។ សមតុល្យស្តុកបញ្ជាក់ថានៅសល់ប៉ុន្មានពិតប្រាកដ។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំ',
        items: [
          'ទំនិញក្នុងស្តុកដែលតាមដានចំនួន',
          'ទីតាំង (ឃ្លាំង និងហាង) ពីផ្នែកគ្រប់គ្រងប្រព័ន្ធ',
          'អ្នកផ្គត់ផ្គង់ ដែលប្រើរួមជាមួយផ្នែកចំណាយ',
          'ប្រភេទទំនិញ ជាមួយការកំណត់គណនីសៀវភៅគណនីទូទៅតាមជម្រើស',
        ],
      },
      {
        title: 'ប្រតិបត្តិការ និងរបាយការណ៍',
        items: [
          'បញ្ជាទិញ និងការទទួលទំនិញចូលស្តុក',
          'ការផ្ទេរ ការកែតម្រូវ និងការដកស្តុក',
          'សមតុល្យស្តុក',
          'របាយការណ៍ស្តុក',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '📦',
        title: 'ស្តុកតាមទីតាំងច្រើន',
        description:
          'តាមដានចំនួនដែលនៅសល់ តាមឃ្លាំង ឬហាង។ ទីតាំងទាំងនេះជាកំណត់ត្រាតែមួយដែលប្រើពេញប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម មិនមែនកម្មវិធីឃ្លាំងដាច់ដោយឡែកទេ។',
        images: [
          '/images/products/inventory/inventory-items.png',
          '/images/products/inventory/inventory-item-form.png',
          '/images/products/inventory/inventory-balances.png',
        ],
      },
      {
        icon: '🧾',
        title: 'ការទិញ និងការទទួលទំនិញ',
        description:
          'ចេញបញ្ជាទិញ រួចទទួលទំនិញចូលទីតាំង។ វិក្កយបត្រអ្នកផ្គត់ផ្គង់ក្នុងផ្នែកចំណាយ អាចធ្វើតាមការទទួលទំនិញ។',
        images: [
          '/images/products/inventory/inventory-purchase-orders.png',
          '/images/products/inventory/inventory-purchase-order-form.png',
          '/images/products/inventory/inventory-received.png',
          '/images/products/inventory/inventory-received-form.png',
        ],
      },
      {
        icon: '🔄',
        title: 'ការផ្ទេរ ការកែតម្រូវ និងការដកស្តុក',
        description:
          'ផ្លាស់ទីស្តុករវាងទីតាំង កែតម្រូវក្រោយការរាប់ស្តុក ឬចេញការដកស្តុក។ បុគ្គលិកអាចស្នើដកស្តុកតាមសេវាដោយខ្លួនឯង ហើយបុគ្គលិកឃ្លាំងបំពេញសំណើដែលបានអនុម័ត។',
        images: [
          '/images/products/inventory/inventory-transfers.png',
          '/images/products/inventory/inventory-transfer-form.png',
          '/images/products/inventory/inventory-adjustments.png',
          '/images/products/inventory/inventory-adjustment-form.png',
          '/images/products/inventory/inventory-withdrawals.png',
          '/images/products/inventory/inventory-withdrawal-form.png',
        ],
      },
      {
        icon: '📊',
        title: 'សមតុល្យ និងរបាយការណ៍',
        description:
          'ផ្ទៀងផ្ទាត់ចំនួនដែលនៅសល់ ក្រោយការទទួល ការផ្ទេរ និងការលក់។ របាយការណ៍ស្តុកបង្ហាញចលនា និងចំនួនដែលនៅសល់។',
        images: [
          '/images/products/inventory/inventory-balances.png',
          '/images/products/inventory/inventory-reports.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS ស្តុក | បញ្ជាទិញ ការទទួលទំនិញ ការផ្ទេរ និងសមតុល្យ',
      description:
        'AKAS ជួយគ្រប់គ្រងទំនិញក្នុងស្តុក បញ្ជាទិញ ការទទួលទំនិញ ការផ្ទេរ ការកែតម្រូវ ការដកស្តុក និងសមតុល្យតាមទីតាំងនានា។',
      keywords:
        'ស្តុក, ឃ្លាំង, បញ្ជាទិញ, ការផ្ទេរស្តុក, សមតុល្យស្តុក, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🛒',
        title: 'ភ្ជាប់ជាមួយការលក់',
        description: 'ការចេញវិក្កយបត្រលើទំនិញក្នុងស្តុក ក្នុងការគ្រប់គ្រងចំណូល ដកស្តុកដោយស្វ័យប្រវត្តិ។',
      },
      {
        icon: '💻',
        title: 'ការដកស្តុកដោយខ្លួនឯង',
        description: 'បុគ្គលិកស្នើដកស្តុក តាម «ផ្ទាំងគ្រប់គ្រង» → «សេវាដោយខ្លួនឯង» → «សំណើដកស្តុក»។',
      },
      {
        icon: '🔔',
        title: 'ការអនុម័ត និងកំណត់ត្រា',
        description: 'ចលនាស្តុកអាចត្រូវការការអនុម័ត ហើយកំណត់ត្រាទិន្នន័យបង្ហាញថាអ្នកណាបានកែស្តុក។',
      },
      {
        icon: '🏪',
        title: 'ការលក់តាមបញ្ជរ និងហាង',
        description: 'ទំនិញ និងទីតាំងដូចគ្នា ប្រើសម្រាប់ការលក់តាមបញ្ជរ និងហាងអនឡាញ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'ដឹងច្បាស់ថានៅសល់ប៉ុន្មាន',
        description: 'សមតុល្យធ្វើបច្ចុប្បន្នភាពពីការទទួល ការផ្ទេរ ការដកស្តុក និងការលក់ — មិនមែនពីការរាប់ស្តុកប្រចាំសប្តាហ៍តែម្តងទេ។',
      },
      {
        number: '02',
        title: 'ការទិញមានផ្លូវដាន',
        description: 'បញ្ជាទិញ និងការទទួលទំនិញ ស្ថិតក្បែរវិក្កយបត្រអ្នកផ្គត់ផ្គង់ មិនមែនក្នុងឧបករណ៍ទិញដាច់ដោយឡែកទេ។',
      },
      {
        number: '03',
        title: 'កាត់បន្ថយការខ្វះស្តុកដោយអាសន្ន',
        description: 'ការលក់ដកទំនិញក្នុងស្តុក ដូច្នេះការលក់តាមបញ្ជរ ឬការចេញវិក្កយបត្រលើកក្រោយ ឃើញចំនួនត្រឹមត្រូវ។',
      },
      {
        number: '04',
        title: 'បុគ្គលិកស្នើស្តុកបាន',
        description: 'ការដកស្តុកដោយខ្លួនឯង ធ្វើឱ្យការប្រើប្រាស់ផ្ទៃក្នុងស្ថិតលើសៀវភៅគណនីតែមួយ ជាមួយការចេញស្តុកពីឃ្លាំង។',
      },
    ],
    related: [
      { label: 'ចំណាយ', to: '/products/expenses' },
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
      { label: 'ការលក់តាមបញ្ជរ', to: '/products/pos' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើស្តុក', href: `${DOCS_ORIGIN}/en/inventory/` },
    ],
  },
  {
    id: 7,
    slug: 'clinic',
    name: 'ការគ្រប់គ្រងគ្លីនិក',
    shortName: 'គ្លីនិក',
    navLabel: 'គ្រប់គ្រងគ្លីនិក',
    tagline: 'ជួររង់ចាំ ពិគ្រោះយោបល់ ចេញវេជ្ជបញ្ជា ចែកឱសថ និងទទួលប្រាក់',
    featured: true,
    description:
      'AKAS គ្រប់គ្រងគ្លីនិក ដំណើរការចាប់ពីផ្នែកទទួលភ្ញៀវរហូតដល់ការទូទាត់៖ ជួររង់ចាំ ការណាត់ជួប កំណត់ត្រាអេឡិចត្រូនិក ការពិគ្រោះយោបល់ និងការចេញវេជ្ជបញ្ជា ស្តុកឱសថ ការចេញវិក្កយបត្រ និងការទទួលប្រាក់តាម KHQR។ ប្រព័ន្ធមានពហុភាសា និងដំណើរការលើកម្មវិធីរុករកតាមអ៊ីនធឺណិត លើកុំព្យូទ័រ និងថេប្លេតរបស់គ្លីនិក។',
    images: [
      '/images/products/clinic-queue.png',
      '/images/products/clinic-appointment.png',
      '/images/products/clinic-consultation.png',
      '/images/products/clinic-prescription.png',
      '/images/products/clinic-dispensary.png',
      '/images/products/clinic-payment.png',
      '/images/products/clinic-dashboard.png',
    ],
    backgroundImage: '/images/products/clinic-bg.gif',
    highlights: [
      'ការគ្រប់គ្រងជួររង់ចាំ និងការណាត់ជួប',
      'ការពិគ្រោះយោបល់ ការចេញវេជ្ជបញ្ជា និងកំណត់ត្រាសុខភាពអេឡិចត្រូនិក',
      'ស្តុកឱសថរបស់គ្លីនិក',
      'ការចេញវិក្កយបត្រ ជាមួយការទូទាត់តាម KHQR',
    ],
    workflow: {
      title: 'ការមកពិនិត្យរបស់អ្នកជំងឺ',
      path: 'ជួររង់ចាំ / ការណាត់ជួប → ពិគ្រោះយោបល់ → ចេញវេជ្ជបញ្ជា → ចែកឱសថ → ទូទាត់',
      steps: [
        {
          title: 'មកដល់',
          description: 'ដាក់អ្នកជំងឺក្នុងជួររង់ចាំ ឬអនុវត្តតាមការណាត់ជួបដែលបានកក់ទុក។',
        },
        {
          title: 'ពិគ្រោះ និងកត់ត្រា',
          description: 'កត់ត្រាការមកពិនិត្យក្នុងកំណត់ត្រាអេឡិចត្រូនិក រួចសរសេរវេជ្ជបញ្ជា។',
        },
        {
          title: 'ចែកឱសថ',
          description: 'ចេញឱសថពីស្តុកឱសថ ជាមួយកំណត់ត្រាចលនាចេញចូល។',
        },
        {
          title: 'ទូទាត់',
          description: 'ចេញវិក្កយបត្រសម្រាប់ការមកពិនិត្យ និងទទួលប្រាក់ រួមទាំងតាម KHQR។',
        },
      ],
    },
    mainFeatures: [
      {
        icon: '💻',
        title: 'ការគ្រប់គ្រងជួររង់ចាំ',
        description:
          'តាមដានអ្នកដែលកំពុងរង់ចាំជាក់ស្តែង ដើម្បីឱ្យបុគ្គលិកហៅអ្នកជំងឺបន្ទាប់បាន ដោយមិនចាំបាច់ស្រែកឆ្លងកាត់បន្ទប់រង់ចាំ។',
        images: ['/images/products/clinic-queue.png'],
      },
      {
        icon: '📅',
        title: 'ការកំណត់ការណាត់ជួប',
        description:
          'កក់ការមកពិនិត្យ មើលកាលវិភាគប្រចាំថ្ងៃភ្លាមៗ និងភ្ជាប់ការណាត់ជួបទៅកំណត់ត្រាអ្នកជំងឺ នៅពេលអ្នកជំងឺមកដល់។',
        images: ['/images/products/clinic-appointment.png'],
      },
      {
        icon: '📊',
        title: 'កំណត់ត្រាសុខភាពអេឡិចត្រូនិក',
        description:
          'រក្សាការធ្វើរោគវិនិច្ឆ័យ ការព្យាបាល ឱសថ និងប្រវត្តិនៃការមកពិនិត្យ លើកំណត់ត្រាអ្នកជំងឺ — ដែលគ្រូពេទ្យបន្ទាប់អាចមើលបានភ្លាម នៅពេលបើកកំណត់ត្រា។',
        images: ['/images/products/clinic-ehr.png'],
      },
      {
        icon: '🩺',
        title: 'ការពិគ្រោះយោបល់ និងការចេញវេជ្ជបញ្ជា',
        description:
          'កត់ត្រាការពិគ្រោះ និងចេញវេជ្ជបញ្ជា ដែលបន្ទប់ឱសថអាចរៀបចំបាន ដោយមិនវាយបញ្ចូលឈ្មោះឱសថ និងកម្រិតថ្នាំឡើងវិញ។',
        images: [
          '/images/products/clinic-consultation.png',
          '/images/products/clinic-prescription.png',
        ],
      },
      {
        icon: '💊',
        title: 'ការគ្រប់គ្រងបន្ទប់ឱសថ',
        description:
          'ធ្វើឱ្យស្តុកឱសថរបស់គ្លីនិកទាន់សម័យ៖ ការចេញឱសថ ការកែតម្រូវ និងផ្លូវដានថាឱសថអ្វីបានចេញពីធ្នើ។',
        images: ['/images/products/clinic-dispensary.png'],
      },
      {
        icon: '💳',
        title: 'ការចេញវិក្កយបត្រ និងការទូទាត់',
        description:
          'បង្កើតវិក្កយបត្រ និងបង្កាន់ដៃសម្រាប់ការពិគ្រោះ និងការព្យាបាល ព្រមទាំងទទួលប្រាក់តាមវិធីដូចជា KHQR។',
        images: ['/images/products/clinic-payment.png'],
      },
    ],
    meta: {
      title: 'AKAS គ្រប់គ្រងគ្លីនិក | ជួររង់ចាំ កំណត់ត្រាអេឡិចត្រូនិក បន្ទប់ឱសថ និងការចេញវិក្កយបត្រតាម KHQR',
      description:
        'AKAS គ្រប់គ្រងគ្លីនិក រួមមាន ជួររង់ចាំ ការណាត់ជួប កំណត់ត្រាអេឡិចត្រូនិក វេជ្ជបញ្ជា ស្តុកឱសថ ការចេញវិក្កយបត្រ និងការទូទាត់តាម KHQR។',
      keywords:
        'ការគ្រប់គ្រងគ្លីនិក, កំណត់ត្រាសុខភាពអេឡិចត្រូនិក, ការណាត់ជួប, បន្ទប់ឱសថ, គ្លីនិក KHQR, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ផ្នែកទទួលភ្ញៀវ និងគ្រូពេទ្យ អាចធ្វើការជាភាសាណាមួយក៏បាន។',
      },
      {
        icon: '📁',
        title: 'ការគ្រប់គ្រងឯកសារ',
        description: 'រក្សាកំណត់ចំណាំនៃការមកពិនិត្យ ឯកសារ និងប្រវត្តិ លើកំណត់ត្រាអ្នកជំងឺ។',
      },
      {
        icon: '⚙️',
        title: 'កែតម្រូវបានតាមតម្រូវការ',
        description: 'បន្ថែមវាល និងរបាយការណ៍ សម្រាប់របៀបដំណើរការពិតប្រាកដរបស់គ្លីនិកអ្នក។',
      },
      {
        icon: '🔔',
        title: 'ការជូនដំណឹងភ្លាមៗ',
        description: 'ព្រឹត្តិការណ៍ជួររង់ចាំ ការណាត់ជួប និងស្តុក បង្ហាញភ្លាមៗនៅពេលកើតឡើង។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'រង់ចាំខ្លីជាងមុន',
        description: 'ជួររង់ចាំ និងការណាត់ជួប ផ្តល់ឱ្យបុគ្គលិកនូវព័ត៌មានតែមួយថាអ្នកណាជាបន្ទាប់។',
      },
      {
        number: '02',
        title: 'កំណត់ត្រាអ្នកជំងឺតែមួយ',
        description: 'ការពិគ្រោះ វេជ្ជបញ្ជា និងការចេញឱសថ ស្ថិតលើការមកពិនិត្យតែមួយ។',
      },
      {
        number: '03',
        title: 'ស្តុកត្រូវនឹងវេជ្ជបញ្ជា',
        description: 'ចលនាឱសថដើរតាមវេជ្ជបញ្ជា មិនមែនកត់ក្នុងសៀវភៅដាច់ដោយឡែកទេ។',
      },
      {
        number: '04',
        title: 'ទូទាត់មុនពេលអ្នកជំងឺចេញ',
        description: 'ការចេញវិក្កយបត្រ និងការទូទាត់តាម KHQR បិទការមកពិនិត្យ ដោយមិនចាំបាច់មានប្រព័ន្ធគិតលុយដាច់ដោយឡែក។',
      },
    ],
    related: [
      { label: 'ការបង្ហាញគ្លីនិកផ្ទាល់', to: '/demo' },
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
    ],
  },
  {
    id: 8,
    slug: 'pos',
    name: 'ការលក់តាមបញ្ជរ',
    shortName: 'បញ្ជរ',
    navLabel: 'ការលក់តាមបញ្ជរ',
    tagline: 'ការទូទាត់នៅហាងទំនិញ និងភោជនីយដ្ឋាន លើ Windows, macOS និង Android',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/pos/`,
    description:
      'ម៉ូឌុលលក់តាមបញ្ជររបស់ AKAS ត្រូវបានបង្កើតសម្រាប់ការលក់រាយប្រចាំថ្ងៃ (ហាងទំនិញ) និងប្រតិបត្តិការភោជនីយដ្ឋាន។ អ្នកគិតលុយចូលប្រព័ន្ធ ជ្រើសរើសរបៀប រួចលក់៖ ស្វែងរក ឬស្កេនទំនិញ ទទួលប្រាក់ និងបោះពុម្ពបង្កាន់ដៃ។ របៀបភោជនីយដ្ឋានបន្ថែម ជាន់ តុ ការកុម្ម៉ង់ និងការបោះពុម្ពទៅផ្ទះបាយ។ ស្តុក តម្លៃ និងទំនិញ មកពីបញ្ជីតែមួយ ដូចការគ្រប់គ្រងចំណូល និងការគ្រប់គ្រងស្តុក ដូច្នេះការលក់នៅគ្រឿងគិតលុយ មិនមែនជាទិន្នន័យដាច់ដោយឡែកទេ។',
    images: [
      '/images/products/pos/pos-login.png',
      '/images/products/pos/pos-mart-main.png',
      '/images/products/pos/pos-mart-checkout.png',
      '/images/products/pos/pos-mart-checkout-final.png',
      '/images/products/pos/pos-rest.png',
      '/images/products/pos/pos-rest-main.png',
      '/images/products/pos/pos-rest-floor.png',
      '/images/products/pos/pos-rest-floor-create.png',
      '/images/products/pos/pos-rest-table-create.png',
      '/images/products/pos/pos-rest-table-move-resize.png',
      '/images/products/pos/pos-rest-order.png',
      '/images/products/pos/pos-rest-order-2.png',
      '/images/products/pos/pos-rest-checkout.png',
      '/images/products/pos/pos-rest-checkout-complete.png',
      '/images/products/pos/pos-rest-order-kitchen-print.png',
      '/images/products/pos/pos-rest-order-kitchen-print-2.png',
      '/images/products/pos/pos-rest-order-kitchen-reprint.png',
    ],
    backgroundImage: '/images/products/pos/pos-mart-main.png',
    highlights: [
      'របៀបហាងទំនិញ៖ បញ្ជីទំនិញ បាកូដ ការទូទាត់ និងការទទួលប្រាក់',
      'របៀបភោជនីយដ្ឋាន៖ ជាន់ តុ ការបោះពុម្ពទៅផ្ទះបាយ និងការទទួលប្រាក់',
      'កម្មវិធីដើមសម្រាប់ Windows, macOS និង Android',
      'ទំនិញ និងស្តុក ប្រើរួមជាមួយការគ្រប់គ្រងស្តុក និងការគ្រប់គ្រងចំណូល',
    ],
    workflow: {
      title: 'ធ្វើការលក់',
      path: 'ចូលប្រព័ន្ធ → ហាងទំនិញ ឬភោជនីយដ្ឋាន → បន្ថែមទំនិញ / កុម្ម៉ង់តាមតុ → ទូទាត់ → ទទួលប្រាក់',
      steps: [
        {
          title: 'ចូលប្រព័ន្ធ និងជ្រើសរើសរបៀប',
          description: 'បើកកម្មវិធីលក់ រួចជ្រើសរើស ហាងទំនិញ (លក់រាយ) ឬ ភោជនីយដ្ឋាន សម្រាប់វេននោះ។',
        },
        {
          title: 'បង្កើតបញ្ជីទំនិញលក់',
          description:
            'ហាងទំនិញ៖ ស្វែងរក ស្កេន និងបន្ថែមទំនិញពីបញ្ជី។ ភោជនីយដ្ឋាន៖ កំណត់តុ កត់ការកុម្ម៉ង់ និងបោះពុម្ពទៅផ្ទះបាយ។',
        },
        {
          title: 'ទូទាត់',
          description: 'ពិនិត្យសរុប ពន្ធ និងចំនួនទឹកប្រាក់ទទួល។ បញ្ចប់ការទូទាត់ និងចេញបង្កាន់ដៃ។',
        },
        {
          title: 'ស្តុក និងសៀវភៅគណនី ដើរតាម',
          description: 'ទំនិញដែលលក់ ធ្វើបច្ចុប្បន្នភាពស្តុក និងចូលក្នុងកំណត់ត្រាចំណូលដែលគណនេយ្យប្រើ។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ហាងទំនិញ (លក់រាយ)',
        items: [
          'ស្វែងរកនៅផ្នែកខាងលើ និងស្កេនបាកូដ',
          'ត្រងតាមប្រភេទ និងបង្ហាញទំនិញជាក្រឡា',
          'ផ្ទាំងការលក់បច្ចុប្បន្ន ជាមួយពន្ធ និងសរុប',
          'ទូទាត់រហ័ស — គ្រាន់តែចុចគ្រាប់ចុចខ្លីៗ អ្នកគិតលុយក៏បញ្ចប់ការលក់បានលឿន',
        ],
      },
      {
        title: 'ភោជនីយដ្ឋាន',
        items: [
          'ផែនទីជាន់ និងតុ មើលឃើញច្បាស់ — បន្ថែមជាន់ និងដាក់តុតាមទីតាំងពិត',
          'ការកុម្ម៉ង់តាមតុ ជាមួយការបោះពុម្ពទៅផ្ទះបាយ។ ការបោះពុម្ពឡើងវិញ មានតែមុខម្ហូបថ្មីៗ ដូច្នេះផ្ទះបាយមិនចម្អិនម្ហូបតែមួយពីរដងទេ',
          'បោះពុម្ពបង្កាន់ដៃទាំងមូលឡើងវិញ នៅពេលបង្កាន់ដៃបាត់',
          'ទូទាត់ និងទទួលប្រាក់នៅតុ ឬនៅបញ្ជរ ជាមួយគូប៉ុងបញ្ចុះតម្លៃ និងពន្ធនៅលើបង្កាន់ដៃ',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '🖥️',
        title: 'កម្មវិធីសម្រាប់ប្រព័ន្ធប្រតិបត្តិការច្រើន',
        description:
          'ប្រើ AKAS ការលក់តាមបញ្ជរ លើគ្រឿងគិតលុយ Windows កុំព្យូទ័រ Mac និងថេប្លេត Android ជាមួយដំណើរការទូទាត់ដូចគ្នា។',
        images: ['/images/products/pos/pos-login.png'],
      },
      {
        icon: '🛒',
        title: 'ការទូទាត់នៅហាងទំនិញ',
        description:
          'ស្វែងរកទំនិញ ស្កេនបាកូដ បន្ថែមចូលការលក់ រួចបញ្ចប់ការទូទាត់។ អេក្រង់បែងចែកជាផ្នែកស្វែងរក បញ្ជីទំនិញ និងបញ្ជីលក់បច្ចុប្បន្ន។',
        images: [
          '/images/products/pos/pos-mart-main.png',
          '/images/products/pos/pos-mart-checkout.png',
          '/images/products/pos/pos-mart-checkout-final.png',
        ],
      },
      {
        icon: '🍽️',
        title: 'សេវាភោជនីយដ្ឋាន',
        description:
          'គ្រប់គ្រងជាន់ និងតុ កត់ការកុម្ម៉ង់ បោះពុម្ពទៅផ្ទះបាយ បោះពុម្ពឡើងវិញនៅពេលបង្កាន់ដៃបាត់ និងទទួលប្រាក់។',
        images: [
          '/images/products/pos/pos-rest.png',
          '/images/products/pos/pos-rest-main.png',
          '/images/products/pos/pos-rest-floor.png',
          '/images/products/pos/pos-rest-floor-create.png',
          '/images/products/pos/pos-rest-table-create.png',
          '/images/products/pos/pos-rest-table-move-resize.png',
          '/images/products/pos/pos-rest-order.png',
          '/images/products/pos/pos-rest-order-2.png',
          '/images/products/pos/pos-rest-checkout.png',
          '/images/products/pos/pos-rest-checkout-complete.png',
          '/images/products/pos/pos-rest-order-kitchen-print.png',
          '/images/products/pos/pos-rest-order-kitchen-print-2.png',
          '/images/products/pos/pos-rest-order-kitchen-reprint.png',
        ],
      },
      {
        icon: '📦',
        title: 'ស្តុកធ្វើបច្ចុប្បន្នភាព',
        description:
          'ទំនិញដែលលក់ មកពីបញ្ជីរួម។ ស្តុកផ្លាស់ប្តូរតាមការលក់ ដូច្នេះការិយាល័យខាងក្រោយ និងផ្នែកលក់ ឃើញទិន្នន័យត្រូវគ្នា។',
      },
    ],
    meta: {
      title: 'AKAS ការលក់តាមបញ្ជរ | ហាងទំនិញ និងភោជនីយដ្ឋាន',
      description:
        'AKAS គាំទ្រការគិតលុយនៅហាងទំនិញ និងការទទួលការកម្មង់តាមតុនៅភោជនីយដ្ឋាន ជាមួយការបោះពុម្ពទៅផ្ទះបាយ លើ Windows, macOS និង Android ដោយប្រើទំនិញដូចគ្នានឹងការគ្រប់គ្រងស្តុក និងការគ្រប់គ្រងចំណូល។',
      keywords:
        'ការលក់តាមបញ្ជរ, ការលក់តាមបញ្ជរភោជនីយដ្ឋាន, ការលក់រាយ, ការបោះពុម្ពទៅផ្ទះបាយ, បាកូដ, Windows, Android, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'អ្នកគិតលុយអាចធ្វើការជាភាសាណាមួយក៏បាន។',
      },
      {
        icon: '⚡',
        title: 'ដំណើរការបានពេលគ្មានអ៊ីនធឺណិត',
        description: 'បន្តលក់បាន ទោះបណ្តាញដាច់ រួចធ្វើសមកាលកម្មវិញ នៅពេលបណ្តាញត្រឡប់មកវិញ។',
      },
      {
        icon: '🔌',
        title: 'ឧបករណ៍',
        description: 'ភ្ជាប់ម៉ាស៊ីនស្កេន ម៉ាស៊ីនបោះពុម្ពបង្កាន់ដៃ និងថតលុយ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'ប្រើឧបករណ៍ដែលអ្នកមានស្រាប់',
        description: 'Windows, macOS ឬ Android — មិនចាំបាច់ប្តូរគ្រឿងគិតលុយទេ។',
      },
      {
        number: '02',
        title: 'លក់រាយ និងភោជនីយដ្ឋាន ក្នុងកម្មវិធីតែមួយ',
        description: 'របៀបហាងទំនិញ និងភោជនីយដ្ឋាន ប្រើការចូលប្រព័ន្ធ ទំនិញ និងការទូទាត់រួមគ្នា មិនមែនពីអ្នកផ្គត់ផ្គង់ពីរនាក់ទេ។',
      },
      {
        number: '03',
        title: 'ផ្ទះបាយទទួលបានការកុម្ម៉ង់ច្បាស់លាស់',
        description: 'ការបោះពុម្ព និងបោះពុម្ពឡើងវិញនៅភោជនីយដ្ឋាន ធ្វើឱ្យការបញ្ជូនម្ហូបដើរទាន់ពេល។',
      },
      {
        number: '04',
        title: 'គ្រឿងគិតលុយ ជាផ្នែកនៃប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម',
        description: 'ការលក់ចូលស្តុក និងចំណូលផ្ទាល់ មិនមែនតារាងគណនាដាច់ដោយឡែកនៅពេលបិទហាងទេ។',
      },
    ],
    related: [
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
      { label: 'ស្តុក', to: '/products/inventory' },
      { label: 'ហាងអនឡាញ', to: '/products/online-store' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើការលក់តាមបញ្ជរ', href: `${DOCS_ORIGIN}/en/pos/` },
    ],
  },
  {
    id: 9,
    slug: 'accounting',
    name: 'គណនេយ្យ',
    shortName: 'គណនេយ្យ',
    navLabel: 'គណនេយ្យ',
    tagline: 'សៀវភៅគណនីទូទៅ បញ្ជីប្រតិបត្តិការ ថវិកា និងរបាយការណ៍ហិរញ្ញវត្ថុ',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/accounting/`,
    description:
      'គណនេយ្យ គឺជាសៀវភៅគណនីទូទៅរបស់ AKAS។ អ្នករៀបចំផែនទីគណនី បញ្ជីប្រតិបត្តិការ ឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ និងការកំណត់គណនីសម្រាប់ប្រតិបត្តិការ។ វិក្កយបត្រអតិថិជន វិក្កយបត្រអ្នកផ្គត់ផ្គង់ បង្កាន់ដៃ និងការទូទាត់ដែលបានអនុម័ត ពីការគ្រប់គ្រងចំណូល និងចំណាយ នឹងចុះជាកំណត់ត្រាគណនី។ គណនេយ្យករពិនិត្យ ឬបញ្ចូលកំណត់ត្រាគណនីដោយដៃ រួចបង្កើតរបាយការណ៍ចំណូល តារាងតុល្យការណ៍ លំហូរសាច់ប្រាក់ តារាងសមតុល្យសាកល្បង និងថវិកាធៀបនឹងជាក់ស្តែង។ ម៉ឺនុយដើរតាមសិទ្ធិតួនាទី ដូច្នេះត្រូវបំពេញឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ និងអង្គភាព នៅក្នុងការរៀបចំប្រព័ន្ធ មុនពេលចុះបញ្ជី។',
    images: [
      '/images/products/accounting/accounting-coa.png',
      '/images/products/accounting/accounting-coa-form.png',
      '/images/products/accounting/accounting-journals.png',
      '/images/products/accounting/accounting-journal-form.png',
      '/images/products/accounting/accounting-journal-entries.png',
      '/images/products/accounting/accounting-journal-entry-form.png',
      '/images/products/accounting/accounting-journal-mappings.png',
      '/images/products/accounting/accounting-journal-mapping-form.png',
      '/images/products/accounting/accounting-txn-mappings.png',
      '/images/products/accounting/accounting-budgets.png',
      '/images/products/accounting/accounting-budget-form.png',
      '/images/products/accounting/accounting-budget-vs-actual.png',
      '/images/products/accounting/accounting-income-statement.png',
      '/images/products/accounting/accounting-balance-sheet.png',
      '/images/products/accounting/accounting-cash-flow.png',
      '/images/products/accounting/accounting-trial-balance.png',
    ],
    backgroundImage: '/images/products/accounting/accounting-coa.png',
    highlights: [
      'ផែនទីគណនី បញ្ជីប្រតិបត្តិការ និងថវិកា',
      'ការកំណត់គណនីពីវិក្កយបត្រ វិក្កយបត្រត្រូវបង់ និងការទូទាត់',
      'របាយការណ៍ចំណូល តារាងតុល្យការណ៍ លំហូរសាច់ប្រាក់ និងតារាងសមតុល្យសាកល្បង',
      'ថវិកាធៀបនឹងជាក់ស្តែង',
    ],
    workflow: {
      title: 'បិទសៀវភៅគណនីពីប្រតិបត្តិការ',
      path: 'ផែនទីគណនី → ការកំណត់គណនី → ការចុះបញ្ជីពីប្រតិបត្តិការ → របាយការណ៍',
      steps: [
        {
          title: 'រៀបចំរចនាសម្ព័ន្ធសៀវភៅគណនី',
          description: 'បង្កើតផែនទីគណនី និងកំណត់បញ្ជីប្រតិបត្តិការ ឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ និងថវិកា។',
        },
        {
          title: 'កំណត់គណនីសម្រាប់ប្រតិបត្តិការ',
          description: 'ប្រាប់ AKAS ថាវិក្កយបត្រអតិថិជន វិក្កយបត្រអ្នកផ្គត់ផ្គង់ បង្កាន់ដៃ និងការទូទាត់ ត្រូវចុះទៅគណនីណា។',
        },
        {
          title: 'ដំណើរការ',
          description: 'ការគ្រប់គ្រងចំណូល និងចំណាយ ចុះកំណត់ត្រាគណនី នៅពេលឯកសារត្រូវបានអនុម័ត។',
        },
        {
          title: 'ពិនិត្យ និងរាយការណ៍',
          description:
            'ពិនិត្យកំណត់ត្រាគណនី បន្ថែមការកែតម្រូវដោយដៃ រួចបង្កើតរបាយការណ៍ហិរញ្ញវត្ថុ និងថវិកាធៀបនឹងជាក់ស្តែង។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំ',
        items: [
          'ផែនទីគណនី',
          'បញ្ជីប្រតិបត្តិការ',
          'ថវិកា',
          'ការកំណត់គណនីសម្រាប់ឯកសារប្រតិបត្តិការ',
          'ការកំណត់គណនីសម្រាប់កំណត់ត្រាគណនី',
        ],
      },
      {
        title: 'ប្រតិបត្តិការ និងរបាយការណ៍',
        items: [
          'កំណត់ត្រាគណនី (ពិនិត្យការចុះពីប្រតិបត្តិការ និងបញ្ចូលការកែតម្រូវ)',
          'របាយការណ៍ចំណូល',
          'តារាងតុល្យការណ៍',
          'របាយការណ៍លំហូរសាច់ប្រាក់',
          'តារាងសមតុល្យសាកល្បង',
          'ថវិកាធៀបនឹងជាក់ស្តែង',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '📒',
        title: 'ផែនទីគណនី និងបញ្ជីប្រតិបត្តិការ',
        description:
          'កំណត់រចនាសម្ព័ន្ធគណនី និងបញ្ជីប្រតិបត្តិការដែលកំណត់ត្រានឹងចុះចូល។ ឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ និងអង្គភាពក្នុងផ្នែកគ្រប់គ្រងប្រព័ន្ធ ជាអ្នកកំណត់ថាពេលណាអាចចុះបញ្ជីបាន។',
        images: [
          '/images/products/accounting/accounting-coa.png',
          '/images/products/accounting/accounting-coa-form.png',
          '/images/products/accounting/accounting-journals.png',
          '/images/products/accounting/accounting-journal-form.png',
        ],
      },
      {
        icon: '🔗',
        title: 'ការកំណត់គណនី',
        description:
          'កំណត់វិក្កយបត្រ វិក្កយបត្រត្រូវបង់ បង្កាន់ដៃ និងការទូទាត់ ទៅគណនីនានា ដើម្បីឱ្យប្រតិបត្តិការចុះសៀវភៅគណនីដោយខ្លួនឯង ជំនួសការវាយបញ្ចូលឡើងវិញដោយផ្នែកហិរញ្ញវត្ថុ។',
        images: [
          '/images/products/accounting/accounting-journal-mappings.png',
          '/images/products/accounting/accounting-journal-mapping-form.png',
          '/images/products/accounting/accounting-txn-mappings.png',
        ],
      },
      {
        icon: '✍️',
        title: 'កំណត់ត្រាគណនី',
        description:
          'ពិនិត្យកំណត់ត្រាដែលចុះដោយស្វ័យប្រវត្តិ និងបង្កើតការកែតម្រូវដោយដៃ នៅពេលអ្នកត្រូវការកំណត់ត្រាកែតម្រូវ។',
        images: [
          '/images/products/accounting/accounting-journal-entries.png',
          '/images/products/accounting/accounting-journal-entry-form.png',
        ],
      },
      {
        icon: '📈',
        title: 'របាយការណ៍ហិរញ្ញវត្ថុ',
        description:
          'របាយការណ៍ចំណូល តារាងតុល្យការណ៍ លំហូរសាច់ប្រាក់ តារាងសមតុល្យសាកល្បង និងថវិកាធៀបនឹងជាក់ស្តែង — ចេញពីសៀវភៅគណនីតែមួយ ដែលផ្នែកប្រតិបត្តិការចុះចូល។',
        images: [
          '/images/products/accounting/accounting-income-statement.png',
          '/images/products/accounting/accounting-balance-sheet.png',
          '/images/products/accounting/accounting-cash-flow.png',
          '/images/products/accounting/accounting-trial-balance.png',
          '/images/products/accounting/accounting-budget-vs-actual.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS គណនេយ្យ | សៀវភៅគណនីទូទៅ បញ្ជីប្រតិបត្តិការ និងរបាយការណ៍ហិរញ្ញវត្ថុ',
      description:
        'AKAS ជួយគ្រប់គ្រងផែនទីគណនី ការកំណត់គណនី កំណត់ត្រាគណនី ថវិកា និងរបាយការណ៍ រួមទាំងរបាយការណ៍ចំណូល តារាងតុល្យការណ៍ លំហូរសាច់ប្រាក់ និងតារាងសមតុល្យសាកល្បង។',
      keywords:
        'គណនេយ្យ, សៀវភៅគណនីទូទៅ, របាយការណ៍ចំណូល, តារាងតុល្យការណ៍, លំហូរសាច់ប្រាក់, តារាងសមតុល្យសាកល្បង, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🏢',
        title: 'ការរៀបចំអង្គភាព និងឆ្នាំហិរញ្ញវត្ថុ',
        description: 'នីតិបុគ្គល អង្គភាព និងឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ កំណត់ពីផ្នែកគ្រប់គ្រងប្រព័ន្ធ មុនពេលចុះបញ្ជី។',
      },
      {
        icon: '🔒',
        title: 'សិទ្ធិតាមតួនាទី',
        description: 'ម៉ឺនុយរបាយការណ៍ និងបញ្ជីប្រតិបត្តិការ បង្ហាញតាមតួនាទីរបស់អ្នកប្រើ។',
      },
      {
        icon: '🏗️',
        title: 'ទ្រព្យសកម្មអចលនៈ',
        description: 'ការរំលស់ចុះចូលសៀវភៅគណនីតែមួយ នៅពេលក្រុមទ្រព្យសកម្មត្រូវបានកំណត់គណនី។',
      },
      {
        icon: '🌐',
        title: 'ពហុភាសា',
        description: 'ក្រុមហិរញ្ញវត្ថុអាចធ្វើការជាភាសាណាមួយក៏បាន។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'មិនចាំបាច់វាយបញ្ចូលពីរដងពីប្រតិបត្តិការ',
        description: 'ការលក់ និងគណនីត្រូវបង់ដែលបានកំណត់គណនី ចុះកំណត់ត្រាគណនី នៅពេលឯកសារត្រូវបានអនុម័ត។',
      },
      {
        number: '02',
        title: 'របាយការណ៍ចេញពីសៀវភៅគណនីតែមួយ',
        description: 'របាយការណ៍ចំណូល តារាងតុល្យការណ៍ និងលំហូរសាច់ប្រាក់ សុទ្ធតែជាទិដ្ឋភាពនៃកំណត់ត្រាគណនីតែមួយ។',
      },
      {
        number: '03',
        title: 'ថវិកាដែលអ្នកប្រៀបធៀបបាន',
        description: 'ថវិកាធៀបនឹងជាក់ស្តែង ជារបាយការណ៍ពេញលេញក្នុងប្រព័ន្ធ មិនមែនការនាំចេញទៅតារាងគណនាទេ។',
      },
      {
        number: '04',
        title: 'ការកែតម្រូវមានផ្លូវដានឱ្យពិនិត្យ',
        description: 'កំណត់ត្រាគណនីដោយដៃ ស្ថិតក្បែរការចុះពីប្រតិបត្តិការ ជាមួយឈ្មោះអ្នកប្រើ និងពេលវេលា។',
      },
    ],
    related: [
      { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
      { label: 'ចំណាយ', to: '/products/expenses' },
      { label: 'ទ្រព្យសកម្មអចលនៈ', to: '/products/fixed-assets' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើគណនេយ្យ', href: `${DOCS_ORIGIN}/en/accounting/` },
    ],
  },
  {
    id: 10,
    slug: 'fixed-assets',
    name: 'ទ្រព្យសកម្មអចលនៈ',
    shortName: 'ទ្រព្យសកម្ម',
    navLabel: 'ទ្រព្យសកម្មអចលនៈ',
    tagline: 'ចុះឈ្មោះទ្រព្យសកម្ម ចាត់ថ្នាក់ និងចុះការរំលស់',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/fixed-assets/`,
    description:
      'ម៉ូឌុលទ្រព្យសកម្មអចលនៈ ជួយគ្រប់គ្រងទ្រព្យសកម្មរយៈពេលវែង និងការរំលស់។ កំណត់ក្រុមទ្រព្យសកម្ម ជាមួយអាយុកាលប្រើប្រាស់ ចុះឈ្មោះទ្រព្យសកម្មម្នាក់ៗ (ជាមួយទីតាំង និងអ្នកផ្គត់ផ្គង់ នៅពេលពាក់ព័ន្ធ) រួចគណនាការរំលស់តាមកាលកំណត់ ចូលសៀវភៅគណនីទូទៅ។ គួររៀបចំផែនទីគណនីក្នុងផ្នែកគណនេយ្យ មុនពេលចុះការរំលស់។',
    images: [
      '/images/products/fixed-assets/fa-asset-classes.png',
      '/images/products/fixed-assets/fa-asset-class-form.png',
      '/images/products/fixed-assets/fa-assets.png',
      '/images/products/fixed-assets/fa-asset-form.png',
      '/images/products/fixed-assets/fa-depreciation.png',
      '/images/products/fixed-assets/fa-reports.png',
    ],
    backgroundImage: '/images/products/fixed-assets/fa-assets.png',
    highlights: [
      'ក្រុមទ្រព្យសកម្ម ជាមួយអាយុកាលប្រើប្រាស់',
      'បញ្ជីទ្រព្យសកម្ម ជាមួយទីតាំង និងអ្នកផ្គត់ផ្គង់',
      'ការចុះការរំលស់តាមកាលកំណត់',
      'របាយការណ៍ទ្រព្យសកម្មអចលនៈ',
    ],
    workflow: {
      title: 'កំណត់ជាទ្រព្យសកម្ម និងរំលស់',
      path: 'ក្រុមទ្រព្យសកម្ម → ចុះឈ្មោះទ្រព្យសកម្ម → គណនាការរំលស់',
      steps: [
        {
          title: 'កំណត់ក្រុម',
          description: 'កំណត់ប្រភេទ និងអាយុកាលប្រើប្រាស់ ដើម្បីឱ្យទ្រព្យសកម្មប្រភេទដូចគ្នា រំលស់ក្នុងអត្រាដូចគ្នា។',
        },
        {
          title: 'ចុះឈ្មោះទ្រព្យសកម្ម',
          description: 'កត់ត្រាទ្រព្យសកម្មម្នាក់ៗ ទីតាំង និងអ្នកផ្គត់ផ្គង់ តាមការចាំបាច់។',
        },
        {
          title: 'ដំណើរការការរំលស់',
          description: 'គណនា និងចុះកំណត់ត្រារំលស់តាមកាលកំណត់ ចូលសៀវភៅគណនី។',
        },
        {
          title: 'រាយការណ៍',
          description: 'ប្រើរបាយការណ៍ទ្រព្យសកម្មអចលនៈ សម្រាប់បញ្ជី និងការរំលស់បង្គរ។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ទំព័រ',
        items: [
          'ក្រុមទ្រព្យសកម្ម',
          'បញ្ជីទ្រព្យសកម្មអចលនៈ',
          'គណនាការរំលស់',
          'របាយការណ៍ទ្រព្យសកម្មអចលនៈ',
          'ទីតាំង និងអ្នកផ្គត់ផ្គង់ ពីម៉ឺនុយរៀបចំរួម',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '🏷️',
        title: 'ក្រុមទ្រព្យសកម្ម',
        description: 'ដាក់ទ្រព្យសកម្មជាក្រុម តាមប្រភេទ និងអាយុកាលប្រើប្រាស់ ដើម្បីកុំឱ្យគោលនយោបាយរំលស់អាស្រ័យលើតារាងគណនាមួយៗ។',
        images: [
          '/images/products/fixed-assets/fa-asset-classes.png',
          '/images/products/fixed-assets/fa-asset-class-form.png',
        ],
      },
      {
        icon: '📋',
        title: 'បញ្ជីទ្រព្យសកម្ម',
        description: 'ទ្រព្យសកម្មម្នាក់ៗ មានអត្តសញ្ញាណ ក្រុម និងទីតាំង ឬអ្នកផ្គត់ផ្គង់តាមជម្រើស — ដោយប្រើទីតាំង និងអ្នកផ្គត់ផ្គង់ដូចគ្នានឹងផ្នែកផ្សេងទៀតក្នុង AKAS។',
        images: [
          '/images/products/fixed-assets/fa-assets.png',
          '/images/products/fixed-assets/fa-asset-form.png',
        ],
      },
      {
        icon: '📉',
        title: 'ការរំលស់',
        description: 'ចុះការរំលស់តាមកាលកំណត់ ចូលគណនេយ្យ ជំនួសការកែសៀវភៅគណនីដោយដៃនៅចុងឆ្នាំ។',
        images: [
          '/images/products/fixed-assets/fa-depreciation.png',
        ],
      },
      {
        icon: '📊',
        title: 'របាយការណ៍',
        description: 'របាយការណ៍បញ្ជីទ្រព្យសកម្ម និងការរំលស់ សម្រាប់ផ្នែកហិរញ្ញវត្ថុ និងសវនកម្ម។',
        images: [
          '/images/products/fixed-assets/fa-reports.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS ទ្រព្យសកម្មអចលនៈ | បញ្ជីទ្រព្យសកម្ម ក្រុម និងការរំលស់',
      description:
        'AKAS ជួយគ្រប់គ្រងក្រុមទ្រព្យសកម្ម បញ្ជីទ្រព្យសកម្ម ការចុះការរំលស់តាមកាលកំណត់ និងរបាយការណ៍ទ្រព្យសកម្មអចលនៈ។',
      keywords: 'ទ្រព្យសកម្មអចលនៈ, ការរំលស់, បញ្ជីទ្រព្យសកម្ម, គណនេយ្យ, AKAS',
    },
    additionalFeatures: [
      {
        icon: '📒',
        title: 'ចុះចូលសៀវភៅគណនីទូទៅ',
        description: 'កំណត់ត្រារំលស់ ចុះចូលសៀវភៅគណនីតែមួយ ជាមួយកំណត់ត្រាប្រតិបត្តិការ។',
      },
      {
        icon: '📍',
        title: 'ទីតាំងរួម',
        description: 'ទ្រព្យសកម្មស្ថិតលើទីតាំងក្នុងផ្នែកគ្រប់គ្រងប្រព័ន្ធ ដែលស្តុកក៏ប្រើដែរ។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'ចុះឈ្មោះជាកំណត់ត្រា មិនមែនជាបញ្ជី',
        description: 'ទ្រព្យសកម្មម្នាក់ៗ ជាកំណត់ត្រាដែលមានក្រុម ទីតាំង និងប្រវត្តិ។',
      },
      {
        number: '02',
        title: 'ការរំលស់តាមកាលវិភាគ',
        description: 'ការគណនាតាមកាលកំណត់ចុះចូលសៀវភៅគណនី ហើយអ្នកគ្រាន់តែពិនិត្យករណីពិសេស។',
      },
      {
        number: '03',
        title: 'ស៊ីសង្វាក់ជាមួយគណនេយ្យ',
        description: 'មិនចាំបាច់មានតារាងគណនាទ្រព្យសកម្មអចលនៈដាច់ដោយឡែក ដើម្បីផ្ទៀងផ្ទាត់នៅពេលបិទសៀវភៅទេ។',
      },
      {
        number: '04',
        title: 'ត្រៀមឆ្លើយសំណួរសវនកម្ម',
        description: 'ក្រុម បញ្ជី និងការរំលស់ដែលបានចុះ ស្ថិតក្នុងផ្នែកតែមួយ។',
      },
    ],
    related: [
      { label: 'គណនេយ្យ', to: '/products/accounting' },
      { label: 'ចំណាយ', to: '/products/expenses' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើទ្រព្យសកម្មអចលនៈ', href: `${DOCS_ORIGIN}/en/fixed-assets/` },
    ],
  },
  {
    id: 11,
    slug: 'online-store',
    name: 'ហាងអនឡាញ',
    shortName: 'ហាងអនឡាញ',
    navLabel: 'ហាងអនឡាញ',
    tagline: 'ហាងលក់លើអ៊ីនធឺណិត ដែលប្រើទំនិញ តម្លៃ និងការទូទាត់ជាមួយប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/online-store/`,
    description:
      'ហាងអនឡាញរបស់ AKAS គឺជាកាតាឡុកសម្រាប់អតិថិជន ដែលដំណើរការនៅ yourbrand.akas.co។ អ្នកកំណត់ព័ត៌មានហាង វិធីទូទាត់ បដា ប្រភេទទំនិញ លក្ខខណ្ឌ និងឆានែលសង្គម រួចកែរូបរាងហាងលក់។ ទំនិញ ស្តុក និងការទូទាត់ គឺជាកំណត់ត្រាដូចគ្នានឹងការគ្រប់គ្រងចំណូល និងស្តុក ដូច្នេះការបញ្ជាទិញតាមអនឡាញ មិនមែនជាទិន្នន័យទំនិញទីពីរទេ។ ការទូទាត់គាំទ្រការបង់ប្រាក់ពេលទទួលទំនិញ និង ABA PayWay។ គោលនយោបាយដឹកជញ្ជូនបង្ហាញនៅពេលបើកដំណើរការពាណិជ្ជកម្មអេឡិចត្រូនិក។',
    images: [
      '/images/products/online-store/akas-store-info.png',
      '/images/products/online-store/akas-store-paymethod.png',
      '/images/products/online-store/akas-store-banner-list.png',
      '/images/products/online-store/akas-store-banner-form.png',
      '/images/products/online-store/akas-store-terms.png',
      '/images/products/online-store/akas-store-menu.png',
      '/images/products/online-store/biz-admin-orgchart.png',
      '/images/products/online-store/biz-admin-orgchart-create.png',
      '/images/products/online-store/biz-admin-orgchart-com.png',
    ],
    backgroundImage: '/images/products/online-store/akas-store-info.png',
    highlights: [
      'ហាងលក់នៅ yourbrand.akas.co ជាមួយអត្តសញ្ញាណ និងបដារបស់អ្នក',
      'ការទូទាត់តាម ABA PayWay និងការបង់ប្រាក់ពេលទទួលទំនិញ',
      'ប្រភេទទំនិញ បដា និងលក្ខខណ្ឌដែលកែបាន',
      'កាតាឡុក និងស្តុក ប្រើរួមជាមួយប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម',
    ],
    workflow: {
      title: 'បើកហាង',
      path: 'ព័ត៌មានហាង → ការទូទាត់ → បដា និងលក្ខខណ្ឌ → កែរូបរាង → លក់',
      steps: [
        {
          title: 'ព័ត៌មានហាង',
          description: 'ឈ្មោះ ទំនាក់ទំនង និងអត្តសញ្ញាណហាងសម្រាប់អាជីវកម្មរបស់អ្នក។',
        },
        {
          title: 'វិធីទូទាត់',
          description: 'បើកវិធីដែលអតិថិជនអាចប្រើនៅពេលទូទាត់។',
        },
        {
          title: 'បដា និងលក្ខខណ្ឌ',
          description: 'ផ្សព្វផ្សាយយុទ្ធនាការ និងលក្ខខណ្ឌដែលអនុវត្ត។',
        },
        {
          title: 'កែរូបរាង និងលក់',
          description: 'កែហាងលក់ រួចទទួលការបញ្ជាទិញពីកាតាឡុកទំនិញផ្ទាល់។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំហាង',
        items: [
          'ព័ត៌មានហាង ជាមួយអត្តសញ្ញាណ ពាក្យស្លោក និងពណ៌ម៉ាក',
          'វិធីទូទាត់របស់ហាង — ABA PayWay និងការបង់ប្រាក់ពេលទទួលទំនិញ',
          'បដាហាង និងការកំណត់ «បង្ហាញក្នុងហាង» តាមប្រភេទ ព្រមទាំងគោលនយោបាយដឹកជញ្ជូន',
          'លក្ខខណ្ឌដែលពាណិជ្ជករកែបាន ជាមួយឧបករណ៍បង្កើតគំរូ',
          'ឆានែលសង្គម៖ Telegram, WhatsApp, Facebook, Instagram, TikTok, LinkedIn, X, YouTube',
        ],
      },
      {
        title: 'ការកែរូបរាង',
        items: ['ការកែរូបរាងហាងសម្រាប់ប្លង់ និងអត្តសញ្ញាណ'],
      },
    ],
    mainFeatures: [
      {
        icon: '🏪',
        title: 'អត្តសញ្ញាណហាង',
        description:
          'កំណត់ហាងសាធារណៈ៖ ព័ត៌មាន បដា និងលក្ខខណ្ឌដែលអតិថិជនឃើញមុនពេលទិញ។',
        images: [
          '/images/products/online-store/akas-store-info.png',
          '/images/products/online-store/akas-store-banner-list.png',
          '/images/products/online-store/akas-store-banner-form.png',
          '/images/products/online-store/akas-store-terms.png',
          '/images/products/online-store/akas-store-menu.png',
        ],
      },
      {
        icon: '💳',
        title: 'ការទូទាត់',
        description:
          'ការទូទាត់ទទួលការបង់ប្រាក់ដោយកាតតាម ABA PayWay ការបង់ប្រាក់ពេលទទួលទំនិញ និងវិធីស្កេនដើម្បីបង់ (KHQR) ដែលអ្នកដំណើរការក្នុងការគ្រប់គ្រងចំណូល — ដូច្នេះការបញ្ជាទិញតាមអនឡាញ ចុះក្នុងសៀវភៅដូចគ្នានឹងការលក់ផ្សេងទៀត។',
        images: [
          '/images/products/online-store/akas-store-paymethod.png',
        ],
      },
      {
        icon: '🎨',
        title: 'ការកែរូបរាង',
        description:
          'កែហាងលក់ — អត្តសញ្ញាណ បដា ប្រភេទទំនិញ និងលក្ខខណ្ឌ — ដោយមិនចាំបាច់បង្កើតប្រព័ន្ធពាណិជ្ជកម្មអេឡិចត្រូនិកដាច់ដោយឡែក។',
        images: [
          '/images/products/online-store/biz-admin-orgchart.png',
          '/images/products/online-store/biz-admin-orgchart-create.png',
          '/images/products/online-store/biz-admin-orgchart-com.png',
        ],
      },
      {
        icon: '📦',
        title: 'កាតាឡុករួម',
        description:
          'ទំនិញ តម្លៃ និងភាពអាចលក់បាន មកពីការគ្រប់គ្រងចំណូល និងស្តុក។ ការលក់តាមអនឡាញ តាមបញ្ជរ និងវិក្កយបត្រ ស្របគ្នា។',
      },
    ],
    meta: {
      title: 'AKAS ហាងអនឡាញ | ពាណិជ្ជកម្មអេឡិចត្រូនិកលើកាតាឡុកដូចប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម',
      description:
        'កំណត់ហាងអនឡាញរបស់ AKAS៖ ព័ត៌មានហាង វិធីទូទាត់ បដា លក្ខខណ្ឌ និងការកែរូបរាង ដោយលក់ទំនិញដូចការគ្រប់គ្រងចំណូល និងស្តុក។',
      keywords: 'ពាណិជ្ជកម្មអេឡិចត្រូនិក, ហាងអនឡាញ, ហាង KHQR, ហាងលក់ AKAS, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🚚',
        title: 'គោលនយោបាយដឹកជញ្ជូន',
        description: 'មាននៅពេលបើកដំណើរការពាណិជ្ជកម្មអេឡិចត្រូនិក។',
      },
      {
        icon: '🖥️',
        title: 'ការបង្ហាញសាកល្បងផ្ទាល់',
        description: 'សាកល្បងហាងខាងមុខ និងផ្នែកគ្រប់គ្រងហាង ពីទំព័របង្ហាញសាកល្បងរបស់ AKAS។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'កាតាឡុកតែមួយ',
        description: 'មិនត្រូវការការធ្វើសមកាលកម្មរវាង «ទំនិញលើគេហទំព័រ» និង «ទំនិញក្នុងប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម» ទេ។',
      },
      {
        number: '02',
        title: 'ការទូទាត់ដែលផ្នែកហិរញ្ញវត្ថុដឹងស្រាប់',
        description: 'វិធីទូទាត់កំណត់ក្នុងប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម មិនមែនតែសម្រាប់រូបរាងហាងប៉ុណ្ណោះទេ។',
      },
      {
        number: '03',
        title: 'យុទ្ធនាការដោយមិនចាំបាច់សាងសង់ឡើងវិញ',
        description: 'បដា និងលក្ខខណ្ឌ គឺជាខ្លឹមសារ មិនមែនការងាររបស់អ្នកអភិវឌ្ឍន៍ទេ។',
      },
      {
        number: '04',
        title: 'ការបញ្ជាទិញចូលរួមក្នុងដំណើរការពីសម្រង់តម្លៃដល់ការទទួលប្រាក់',
        description: 'ការលក់តាមអនឡាញ ស្ថិតជាមួយការលក់តាមបញ្ជរ និងវិក្កយបត្រ ក្នុងការគ្រប់គ្រងចំណូល។',
      },
    ],
    related: [
      { label: 'ចំណូល', to: '/products/revenues' },
      { label: 'ការលក់តាមបញ្ជរ', to: '/products/pos' },
      { label: 'សាកល្បងហាង', to: '/demo' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើហាងអនឡាញ', href: `${DOCS_ORIGIN}/en/online-store/` },
    ],
  },
  {
    id: 12,
    slug: 'platform',
    name: 'វេទិកា និងការគ្រប់គ្រងប្រព័ន្ធ',
    shortName: 'វេទិកា',
    navLabel: 'វេទិកា និងការគ្រប់គ្រង',
    tagline: 'រចនាសម្ព័ន្ធអង្គការ ដំណើរការការងារ សិទ្ធិចូលប្រើ វាលផ្ទាល់ខ្លួន និងបញ្ញាសិប្បនិម្មិត',
    featured: true,
    docsUrl: `${DOCS_ORIGIN}/en/admin/`,
    description:
      'ការគ្រប់គ្រងប្រព័ន្ធ គឺជាផ្នែកបញ្ជាសម្រាប់គ្រប់ម៉ូឌុលរបស់ AKAS។ អ្នកកំណត់នីតិបុគ្គល និងរចនាសម្ព័ន្ធអង្គការ ទីតាំង ឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ និងរូបិយប័ណ្ណ។ ធ្វើស្តង់ដារលេខរៀងស្វ័យប្រវត្តិ បញ្ជីតម្លៃ លក្ខខណ្ឌឥណទាន និងគំរូសារ។ រចនាដំណើរការអនុម័តដោយមើលឃើញ បន្ថែមវាលផ្ទាល់ខ្លួន គ្រប់គ្រងការបកប្រែ គ្រប់គ្រងអ្នកប្រើ តួនាទី សិទ្ធិចូលប្រើ និងការផ្ទៀងផ្ទាត់ពីរជាន់ ព្រមទាំងបើកជំនួយការបញ្ញាសិប្បនិម្មិតតាមជម្រើស។ កំណត់ត្រាទិន្នន័យ និងការងារតាមកាលវិភាគ រក្សាដានប្រតិបត្តិការ។',
    images: [
      '/images/products/platform/admin-areas.png',
      '/images/products/platform/admin-location-create.png',
      '/images/products/platform/admin-fiscal-years.png',
      '/images/products/platform/admin-fiscal-year-edit.png',
      '/images/products/platform/admin-autonumbers.png',
      '/images/products/platform/admin-lov.png',
      '/images/products/platform/akas-admin-msg-tpls.png',
      '/images/products/platform/akas-admin-msg-tpl-form.png',
      '/images/products/platform/akas-admin-settings.png',
      '/images/products/platform/admin-01-users-list.png',
      '/images/products/platform/admin-02-user-form.png',
      '/images/products/platform/admin-03-roles-list.png',
      '/images/products/platform/admin-04-role-form.png',
      '/images/products/platform/admin-05-role-permissions.png',
      '/images/products/platform/admin-06-grant-role.png',
      '/images/products/platform/2fa-auth.png',
      '/images/products/platform/2fa-auth-step2.png',
      '/images/products/platform/2fa-auth-step3.png',
      '/images/products/platform/admin-workflows.png',
      '/images/products/platform/admin-workflow-designer.png',
      '/images/products/platform/admin-workflow-form.png',
      '/images/products/platform/admin-workflow-requests.png',
      '/images/products/platform/admin-form-design-mode.png',
      '/images/products/platform/admin-custom-field-form.png',
      '/images/products/platform/admin-translations.png',
      '/images/products/platform/admin-translation-form.png',
      '/images/products/platform/admin-data-logs.png',
      '/images/products/platform/admin-data-log-detail.png',
      '/images/products/platform/admin-system-jobs.png',
      '/images/products/platform/admin-system-job-form.png',
      '/images/products/platform/admin-ai-assistant-chat.png',
      '/images/products/platform/admin-ai-model-settings.png',
      '/images/products/platform/admin-ai-assistant-fab.png',
      '/images/products/platform/admin-ai-assistant-floating.png',
      '/images/products/platform/admin-list-column-settings.png',
    ],
    backgroundImage: '/images/products/platform/admin-workflow-designer.png',
    highlights: [
      'រចនាសម្ព័ន្ធអង្គការ ទីតាំង ឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ រូបិយប័ណ្ណ',
      'កម្មវិធីរចនាដំណើរការការងារដោយមើលឃើញ និងសំណើតាមដំណើរការ',
      'អ្នកប្រើ តួនាទី សិទ្ធិចូលប្រើ និងការផ្ទៀងផ្ទាត់ពីរជាន់',
      'វាលផ្ទាល់ខ្លួន ការបកប្រែ លេខរៀងស្វ័យប្រវត្តិ និងជំនួយការបញ្ញាសិប្បនិម្មិត',
    ],
    workflow: {
      title: 'ដំឡើងប្រព័ន្ធ',
      path: 'រចនាសម្ព័ន្ធអង្គការ និងឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ → ទិន្នន័យមូលដ្ឋាន → សុវត្ថិភាព → ដំណើរការការងារ → កែសម្រួល',
      steps: [
        {
          title: 'រៀបចំរចនាសម្ព័ន្ធក្រុមហ៊ុន',
          description: 'រចនាសម្ព័ន្ធអង្គការ ឡូហ្គោ ទីតាំង ឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ រូបិយប័ណ្ណ និងតំបន់។',
        },
        {
          title: 'ធ្វើទិន្នន័យឱ្យមានស្តង់ដារ',
          description: 'លេខរៀងស្វ័យប្រវត្តិ បញ្ជីតម្លៃ លក្ខខណ្ឌឥណទាន គំរូសារ និងការកំណត់ប្រព័ន្ធ។',
        },
        {
          title: 'រក្សាសុវត្ថិភាពការចូលប្រើ',
          description: 'អ្នកប្រើ តួនាទី សិទ្ធិចូលប្រើ និងការផ្ទៀងផ្ទាត់ពីរជាន់តាមជម្រើស។',
        },
        {
          title: 'បង្កើតស្វ័យប្រវត្តិកម្ម និងកែសម្រួលតាមតម្រូវការ',
          description: 'រចនាដំណើរការការងារ បន្ថែមវាលផ្ទាល់ខ្លួន បកប្រែចំណុចប្រទាក់ កំណត់ការងារតាមកាលវិភាគ និងបើកការសន្ទនាជាមួយបញ្ញាសិប្បនិម្មិត។',
        },
      ],
    },
    capabilities: [
      {
        title: 'ការរៀបចំរចនាសម្ព័ន្ធ',
        items: [
          'រចនាសម្ព័ន្ធអង្គការ និងឡូហ្គោក្រុមហ៊ុន',
          'ទីតាំងសម្រាប់ស្តុក និងទ្រព្យសកម្ម',
          'ឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ',
          'រូបិយប័ណ្ណ និងអត្រាប្តូរប្រាក់',
          'តំបន់ភូមិសាស្ត្រ',
        ],
      },
      {
        title: 'ការធ្វើស្តង់ដារ',
        items: [
          'លេខរៀងស្វ័យប្រវត្តិសម្រាប់វិក្កយបត្រ បញ្ជាទិញ និងលេខសម្គាល់បុគ្គលិក',
          'បញ្ជីតម្លៃ (ប្រភពអតិថិជនសក្ដានុពល ឧស្សាហកម្ម និងផ្សេងទៀត)',
          'លក្ខខណ្ឌឥណទាន',
          'គំរូសារសម្រាប់អ៊ីមែល និងសារខ្លី',
          'ការបកប្រែ (កែពាក្យ ឬបន្ថែមភាសា)',
        ],
      },
      {
        title: 'សុវត្ថិភាព និងប្រតិបត្តិការ',
        items: [
          'អ្នកប្រើ តួនាទី និងសិទ្ធិចូលប្រើ',
          'ការផ្ទៀងផ្ទាត់ពីរជាន់',
          'ដំណើរការការងារ និងសំណើតាមដំណើរការ',
          'ប្លង់ទម្រង់ និងវាលផ្ទាល់ខ្លួន',
          'ជំនួយការបញ្ញាសិប្បនិម្មិត',
          'ការងារតាមកាលវិភាគ និងកំណត់ត្រាទិន្នន័យ',
        ],
      },
    ],
    mainFeatures: [
      {
        icon: '🏢',
        title: 'អង្គការ ទីតាំង ឆ្នាំសិទ្ធិហិរញ្ញវត្ថុ',
        description:
          'បង្កើតនីតិបុគ្គល និងនាយកដ្ឋាន កំណត់ឃ្លាំង និងហាង ព្រមទាំងកំណត់កាលបរិច្ឆេទគណនេយ្យដែលគ្រប់គ្រងការចុះបញ្ជី។',
        images: [
          '/images/products/platform/admin-areas.png',
          '/images/products/platform/admin-location-create.png',
          '/images/products/platform/admin-fiscal-years.png',
          '/images/products/platform/admin-fiscal-year-edit.png',
        ],
      },
      {
        icon: '🔀',
        title: 'ដំណើរការការងារដែលមើលឃើញ',
        description:
          'គូរផ្លូវអនុម័តសម្រាប់ការឈប់សម្រាក សម្រង់តម្លៃ វិក្កយបត្រ និងស្តុក៖ អ្នកណាទទួលសំណើ ការត្រួតពិនិត្យអ្វីខ្លះ អ្នកណាអនុម័ត និងអ្នកណាទទួលការជូនដំណឹង។ ប្រើច្បាប់ដូចគ្នាឡើងវិញនៅផ្នែកផ្សេងទៀត ហើយមើលភ្លាមថាអ្វីកំពុងរង់ចាំនៅណា។',
        images: [
          '/images/products/platform/admin-workflows.png',
          '/images/products/platform/admin-workflow-designer.png',
          '/images/products/platform/admin-workflow-form.png',
          '/images/products/platform/admin-workflow-requests.png',
        ],
      },
      {
        icon: '🔒',
        title: 'អ្នកប្រើ តួនាទី សិទ្ធិចូលប្រើ និងការផ្ទៀងផ្ទាត់ពីរជាន់',
        description:
          'បុគ្គលិកចូលប្រើដោយគណនីផ្ទាល់ខ្លួន — រួមទាំងគណនី Google ឬគណនីក្រុមហ៊ុន — ហើយអាចបន្ថែមការការពារបន្ថែមលើគណនីសំខាន់ៗ។ តួនាទីនីមួយៗមានសិទ្ធិពេញលេញតាមទំព័រ ចាប់ពីមើល និងបញ្ចូល ដល់ការអនុម័ត និងកែតម្រូវទិន្នន័យ ហើយម៉ឺនុយបង្ហាញតាមតួនាទី។ ក្រុមហ៊ុនអតិថិជនអាចទទួលគណនីផតថល ដើម្បីគ្រប់គ្រងឯកសាររបស់ខ្លួន។',
        images: [
          '/images/products/platform/admin-01-users-list.png',
          '/images/products/platform/admin-02-user-form.png',
          '/images/products/platform/admin-03-roles-list.png',
          '/images/products/platform/admin-04-role-form.png',
          '/images/products/platform/admin-05-role-permissions.png',
          '/images/products/platform/admin-06-grant-role.png',
          '/images/products/platform/2fa-auth.png',
          '/images/products/platform/2fa-auth-step2.png',
          '/images/products/platform/2fa-auth-step3.png',
        ],
      },
      {
        icon: '🧩',
        title: 'វាលផ្ទាល់ខ្លួន និងការបកប្រែ',
        description:
          'ចុច និងអូសដើម្បីរៀបទម្រង់ និងបញ្ជីឡើងវិញ បន្ថែមវាលដែលឧស្សាហកម្មរបស់អ្នកត្រូវការ និងមើលប្លង់ទូរស័ព្ទជាមុន — ដោយមិនចាំបាច់ពឹងអ្នកអភិវឌ្ឍន៍កម្មវិធី។ មានភាសាអង់គ្លេស និងខ្មែរ ជាមួយពាក្យដែលអ្នកកែបាន និងភាសាបន្ថែមនៅពេលត្រូវការ។',
        images: [
          '/images/products/platform/admin-form-design-mode.png',
          '/images/products/platform/admin-custom-field-form.png',
          '/images/products/platform/admin-translations.png',
          '/images/products/platform/admin-translation-form.png',
        ],
      },
      {
        icon: '🤖',
        title: 'ជំនួយការបញ្ញាសិប្បនិម្មិត',
        description:
          'បើកជំនួយការសន្ទនាលើទិន្នន័យអាជីវកម្មរបស់អ្នក — «សមតុល្យការឈប់សម្រាករបស់ខ្ញុំ» «វិក្កយបត្រមិនទាន់បង់» — ដោយប្រើសេវាបញ្ញាសិប្បនិម្មិតដែលអ្នកជ្រើសរើស រួមទាំងដំណើរការក្នុងម៉ាស៊ីនផ្ទាល់ បើអ្នកចង់រក្សាទិន្នន័យនៅក្នុងផ្ទះ។',
        images: [
          '/images/products/platform/admin-ai-assistant-chat.png',
          '/images/products/platform/admin-ai-model-settings.png',
          '/images/products/platform/admin-ai-assistant-fab.png',
          '/images/products/platform/admin-ai-assistant-floating.png',
        ],
      },
      {
        icon: '📝',
        title: 'ការងារតាមកាលវិភាគ កំណត់ត្រា និងលេខរៀងស្វ័យប្រវត្តិ',
        description:
          'វិក្កយបត្រ បង្កាន់ដៃ ការទិញ និងលេខសម្គាល់បុគ្គលិក ដើរតាមគំរូលេខរៀងរបស់អ្នកដោយស្វ័យប្រវត្តិ។ ការផ្លាស់ប្តូរវាលសំខាន់ៗ កត់ត្រាថាអ្វីបានផ្លាស់ប្តូរ និងពេលណា ហើយអាចនាំចេញសម្រាប់ការត្រួតពិនិត្យអនុលោមភាព។ ការងារតាមកាលវិភាគ គ្រប់គ្រងការបម្រុងទុក និងការជូនដំណឹងនៅផ្ទៃខាងក្រោយ។',
        images: [
          '/images/products/platform/admin-autonumbers.png',
          '/images/products/platform/admin-data-logs.png',
          '/images/products/platform/admin-data-log-detail.png',
          '/images/products/platform/admin-system-jobs.png',
          '/images/products/platform/admin-system-job-form.png',
          '/images/products/platform/admin-list-column-settings.png',
        ],
      },
    ],
    meta: {
      title: 'AKAS វេទិកា | ដំណើរការការងារ សិទ្ធិចូលប្រើ វាលផ្ទាល់ខ្លួន និងការបកប្រែ',
      description:
        'ការគ្រប់គ្រងប្រព័ន្ធរបស់ AKAS កំណត់រចនាសម្ព័ន្ធអង្គការ ដំណើរការការងារ អ្នកប្រើ និងសិទ្ធិចូលប្រើ វាលផ្ទាល់ខ្លួន ការបកប្រែ ការផ្ទៀងផ្ទាត់ពីរជាន់ ជំនួយការបញ្ញាសិប្បនិម្មិត និងកំណត់ត្រាសវនកម្ម សម្រាប់គ្រប់ម៉ូឌុលនៃប្រព័ន្ធគ្រប់គ្រងអាជីវកម្ម។',
      keywords:
        'ការគ្រប់គ្រងប្រព័ន្ធ, ដំណើរការអនុម័ត, វាលផ្ទាល់ខ្លួន, ប្រព័ន្ធពហុភាសា, ការផ្ទៀងផ្ទាត់ពីរជាន់, វេទិកា AKAS, AKAS',
    },
    additionalFeatures: [
      {
        icon: '🔔',
        title: 'គំរូសារ',
        description: 'កំណត់ទម្រង់អ៊ីមែល និងសារខ្លី ដែលប្រព័ន្ធផ្ញើ។',
      },
      {
        icon: '📁',
        title: 'ការកំណត់ឯកសារ',
        description: 'ប្រភេទឯកសារដែលអនុញ្ញាត និងទំហំអតិបរមាសម្រាប់ការផ្ទុកឡើង។',
      },
      {
        icon: '▶️',
        title: 'ការណែនាំដំណើរការការងារ',
        description: 'មើលកម្មវិធីរចនាក្នុងវីដេអូផលិតផលនៅផ្នែកធនធានមនុស្ស និងទំព័រដើម។',
      },
    ],
    benefits: [
      {
        number: '01',
        title: 'កំណត់តាមតម្រូវការ មិនត្រូវការកែកូដ',
        description: 'ដំណើរការការងារ វាលផ្ទាល់ខ្លួន និងការបកប្រែ ដោះស្រាយសំណើ «យើងធ្វើការខុសគ្នា» ភាគច្រើន។',
      },
      {
        number: '02',
        title: 'សិទ្ធិចូលប្រើដែលពន្យល់បាន',
        description: 'តួនាទី និងសិទ្ធិចូលប្រើ កំណត់ថាអ្នកណាមើលប្រាក់ខែ និងអ្នកណាចុះបញ្ជីគណនី។',
      },
      {
        number: '03',
        title: 'ភាសារបស់អ្នកនៅលើចំណុចប្រទាក់',
        description: 'ការបកប្រែគ្រប់គ្រងក្នុងផ្នែកគ្រប់គ្រង — មានភាសាអង់គ្លេស និងខ្មែរ ព្រមទាំងភាសាបន្ថែមនៅពេលត្រូវការ។',
      },
      {
        number: '04',
        title: 'ដានកត់ត្រានៅពេលមានការផ្លាស់ប្តូរ',
        description: 'កំណត់ត្រាទិន្នន័យ សំណើតាមដំណើរការ និងលេខរៀងស្វ័យប្រវត្តិ គាំទ្រការត្រួតពិនិត្យផ្ទៃក្នុង។',
      },
    ],
    videos: [
      {
        title: 'ដំណើរការអនុម័តដែលបត់បែន',
        youtubeId: 'Rt-Zk9H0rNg',
        description: 'រចនាដំណើរការអនុម័តក្នុង AKAS។',
      },
      {
        title: 'ការកែសម្រួលតាមតម្រូវការ',
        youtubeId: 'RlB4MXPjYXs',
        description: 'ការបង្ហាញសាកល្បងប្លង់ទម្រង់ និងការកែសម្រួល។',
      },
    ],
    related: [
      { label: 'ធនធានមនុស្ស', to: '/products/hrms' },
      { label: 'គណនេយ្យ', to: '/products/accounting' },
      { label: 'មគ្គុទ្ទេសក៍អ្នកប្រើការគ្រប់គ្រងប្រព័ន្ធ', href: `${DOCS_ORIGIN}/en/admin/` },
    ],
  },
];
